import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
  AfterViewChecked,
  ViewChild,
  NgZone,
  DoCheck,
} from '@angular/core';

import { DirectionService } from '../../direction.service';
import {
  Subscription,
  interval,
  BehaviorSubject,
  Observable,
  combineLatest,
  from,
  of,
} from 'rxjs';
import { startWith, switchMap, map } from 'rxjs/operators';
import { DataSharingService } from '../data-shering-service/data-sharing.service';
import { Router } from '@angular/router';
import { DialogService } from '../../dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { PaperTooltipContentComponent } from './tooltips/paper-tooltip.component';
import { MatTooltip } from '@angular/material/tooltip';

import { BranchesService } from 'src/app/super-management/branch/branches.service';
import { UsersService } from 'src/app/super-management/user/users.service';
import { FilesService } from './file.service';
import { Direction } from '@angular/cdk/bidi';
import * as _ from 'lodash';
import { AuthService } from 'src/app/auth/auth.service';

// import { ResizeComponent } from 'src/app/dialog/resize/resize.component';
import {
  trigger,
  animate,
  style,
  transition,
  keyframes,
  state,
} from '@angular/animations';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as e from 'express';
import { FixProductsComponent } from 'src/app/dialog/fix-products/fix-products.component';

import lottie from 'lottie-web';
import * as Sentry from '@sentry/angular';
import { syncIsNotAcademyFromCluster } from 'src/app/utils/is-not-academy';
import {
  PrinterMarginCM,
  getExpressPrinterMarginCM,
  getPrintableArea,
} from 'src/app/utils/express-printer-margin';

@Component({
  selector: 'app-printing-table',
  templateUrl: './printing-table.component.html',
  styleUrls: ['./printing-table.component.scss'],
  host: {
    class: 'fill-screen',
  },
  animations: [
    trigger('rattleAnimation', [
      transition('* <=> *', [
        animate(
          '1.2s',
          keyframes([
            style({ transform: 'scale(1)', offset: 0 }),
            style({ transform: 'scale(1.02) rotate(-1deg)', offset: 0.1 }),
            style({ transform: 'scale(1.05) rotate(-2.5deg)', offset: 0.2 }),
            style({ transform: 'scale(1.063) rotate(-5deg)', offset: 0.3 }),
            style({ transform: 'scale(1.04) rotate(-4.5deg)', offset: 0.4 }),
            style({ transform: 'scale(1.01) rotate(-1.5deg)', offset: 0.5 }),
            style({ transform: 'scale(0.98) rotate(3deg)', offset: 0.6 }),
            style({ transform: 'scale(1.03) rotate(2.5deg)', offset: 0.7 }),
            style({ transform: 'scale(1.02) rotate(0.5deg)', offset: 0.8 }),
            style({ transform: 'scale(0.99) rotate(-1deg)', offset: 0.9 }),
            style({ transform: 'scale(1)', offset: 1 }),
          ])
        ),
      ]),
      transition(':leave', [animate('0s', style({ opacity: 0 }))]),
    ]),
    trigger('textAnimation', [
      transition('* <=> *', [
        animate(
          '1.2s',
          keyframes([
            style({ transform: 'scale(1)', offset: 0 }),
            style({ transform: 'scale(1.005)', offset: 0.1 }),
            style({ transform: 'scale(1.035)', offset: 0.2 }),
            style({ transform: 'scale(1.03)', offset: 0.3 }),
            style({ transform: 'scale(0.995)', offset: 0.4 }),
            style({ transform: 'scale(1)', offset: 0.5 }),
            style({ transform: 'scale(1)', offset: 1 }),
          ])
        ),
      ]),
    ]),
    trigger('paperAnimation', [
      state('state1', style({ transform: 'scale(1)' })),
      state('state2', style({ transform: 'scale(1)' })),
      transition('state1 => state2', [
        animate(
          '1.3s',
          keyframes([
            style({ transform: 'scale(1)', offset: 0 }),
            style({ transform: 'scale(1)', offset: 0.2 }),
            style({ transform: 'scale(1.005) rotate(0.23deg)', offset: 0.3 }),
            style({ transform: 'scale(1.042) rotate(0.5deg)', offset: 0.4 }),
            style({ transform: 'scale(1.03) rotate(0.1deg)', offset: 0.5 }),
            style({ transform: 'scale(0.995) rotate(-0.1deg)', offset: 0.6 }),
            style({ transform: 'scale(1)', offset: 0.7 }),
            style({ transform: 'scale(1)', offset: 1 }),
          ])
        ),
      ]),
      transition('state2 => state1', []),
    ]),
    trigger('mainBtnAnimation', [
      state('state1', style({ transform: 'scale(1)' })),
      state('state2', style({ transform: 'scale(1)' })),
      transition('state1 => state2', [
        animate(
          '1.3s',
          keyframes([
            style({ transform: 'scale(1)', offset: 0 }),
            style({ transform: 'scale(1)', offset: 0.2 }),
            style({ transform: 'scale(1.003) rotate(0.11deg)', offset: 0.3 }),
            style({ transform: 'scale(1.025) rotate(0.3deg)', offset: 0.4 }),
            style({ transform: 'scale(1.015) rotate(0.05deg)', offset: 0.5 }),
            style({ transform: 'scale(0.997) rotate(-0.06deg)', offset: 0.6 }),
            style({ transform: 'scale(1)', offset: 0.7 }),
            style({ transform: 'scale(1)', offset: 1 }),
          ])
        ),
      ]),
      transition('state2 => state1', []),
    ]),
  ],
})
export class PrintingTableComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  imagePrintSettings$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  @ViewChildren('fileElement') fileElements: QueryList<ElementRef>;
  @ViewChildren('fileExpressElement')
  fileExpressElements: QueryList<ElementRef>;
  isScrollNeeded = false;

  isRTL: boolean = true;
  isDarkMode: boolean = false;
  isLoading: boolean = false;
  serverAddress: string = '';
  isLoadingPreview: boolean = false;
  showMessageButton: boolean = false;
  private messageButtonTimeout: any = null;
  private scrollCheckInterval: any = null;
  private directionSubscription: Subscription;
  tooltipDirection: Direction = 'ltr';
  user: any;

  public printingService: string = '';
  public branch: string = '';
  public realBranch: any;
  public branches: any[] = [];
  public filteredBranches: { name: string; systems: string[] }[] = [];
  private printingServiceSubscription: Subscription;
  private branchSubscription: Subscription;
  private phoneUpdatedSub: Subscription;
  private currentInterval: any;
  private previewDialogSubscription: Subscription;
  printServicePapers: any[] = [];
  files: any[] = [];
  proccessingFiles: any[] = [];
  NumOfProcessingFileAlert: number = 0;
  processingFileAlertedArray: any[] = [];
  isProcessingFileDialogOpen: boolean = true;
  /** פלוטר /print – שניות מ-file.created עד דיאלוג "לא סיים עיבוד תוך זמן סביר" */
  private readonly processingFileAlertAfterSec = 350;
  private plotterUploadErrorsShown = new Set<string>();
  private expressUploadErrorsShown = new Set<string>();

  paperCodes: string[] = [];
  paperNames: string[] = [];
  currentFile: any;
  currentImage: any;
  currentImageIndex: number;
  isChosen: boolean = false;
  isPaperTypeLoading: boolean = false;
  isCurrentrotated: boolean = false;
  factor: number = 0;
  // isCurrentBandW: boolean = false;
  selectedPaper: any;
  selectedPaperPermanent: any;
  isAllFilesHavePaper: boolean = false;
  resizedInagePrintSettings: any;
  isFitRequired: boolean = false;
  scaleImageFactor: number = 1;
  isOriginalPossible: boolean = true;
  currentFileIndex: number = 0;
  sortedFilesArray: any[] = [];
  isToRefreshTable: boolean = true;
  isPaperTooltopOpen: boolean = false;
  lastFileId: string = '';
  lastImageIndex: number = 0;
  isBranchCloseInterval: any;
  isCloseStatusInformed: boolean = false;
  maxInkLevelDubble: number = 40;
  
  // Transfer files snackBar management
  transferFilesSnackBarShown: boolean = false;
  transferFilesSnackBarTimestamp: number = 0;
  transferFilesSnackBarInterval: any = null;

  @ViewChild('tooltipScanCopy') tooltipScanCopy: MatTooltip;
  @ViewChild('tooltipFixProducts') tooltipFixProducts: MatTooltip;

  @ViewChild(FixProductsComponent) fixProductsComponent: FixProductsComponent;
  previousTotalOrderdFixProductsPrice: number;

  // rattle animation
  rattle = 'state1';
  rattleInterval: any;

  // no paper animation
  noPaper = 'state1';
  noPaperInterval: any;
  isNoPaperAnimating: boolean = false;
  isAnimatePaperStrong: boolean = false;

  // mainBtn
  mainBtn = 'state1';
  mainBtnInterval: any;
  isOpeningCompMainBtn: boolean = true;
  lastIsAllFilesHavePaper: boolean = false;

  // total Price
  totalOrderPrice: number = 0;
  totalOrderPriceBeforeDiscount: number = 0;
  fixProductsTotalPrice: number = 0;
  // total Price Before Updated
  totalOrderPriceToBeforeUpdate: number = 0;
  totalOrderPriceBeforeDiscountToBeforeUpdate: number = 0;
  fixProductsTotalPriceToBeforeUpdate: number = 0;

  // current image paper inputs
  currentPaperWidth: number;
  currentPaperHeight: number;
  // current image file inputs:
  currentImageWidth: number;
  currentImageHeight: number;
  // current image more inputs
  // isCurrentCenter: boolean = false;
  currentPaperMargin: number = 0;

  // preview container inputs
  previewContainerWidth: number;
  previewContainerHeight: number;
  // preview paper inputs
  previewPaperWidth: number;
  previewPaperHeight: number;
  // preview file inputs:
  previewImageContainerWidth: number;
  previewImageContainerHeight: number;
  previewImageWidth: number;
  previewImageHeight: number;
  // preview more inputs
  previewPaperMargin: number;
  // [express] gaps (cm) between the preview image and the paper edges
  previewGapStartCM: number = 0;
  previewGapEndCM: number = 0;
  previewGapTopCM: number = 0;
  previewGapBottomCM: number = 0;
  branchID: string;
  /** Plotter: 5mm margins; Express: 3mm */
  get borderCM(): number {
    return this.printingService === 'plotter' ? 0.5 : 0.3;
  }

  /** [express] non-pics printer margins (stored in mm), returned in cm; null unless all 4 sides are valid */
  getExpressPrinterMarginCM(): PrinterMarginCM | null {
    if (this.printingService !== 'express' || this.isPicsPrinter()) {
      return null;
    }
    return getExpressPrinterMarginCM(this.realBranch?.express);
  }

  /** [express] paper area left after removing the printer margins (cm) */
  getExpressPrintableArea(
    paperWidth: number,
    paperHeight: number
  ): { width: number; height: number } {
    return getPrintableArea(
      paperWidth,
      paperHeight,
      this.getExpressPrinterMarginCM()
    );
  }
  isBorderDialogOpened: boolean = false;

  phoneNumber: string = '97233746962';
  expressServerAdress: string = 'https://img-express.eazix.io';

  //pics discount
  confettiAnimation: any;
  isPicsDiscountAvalbleTimeOut: boolean = true;
  isPicsDiscountUsed: boolean = false;
  picsDiscountPresentege: number = 0.3;
  lang: string = 'he';

  constructor(
    public directionService: DirectionService,
    private dataSharingService: DataSharingService,
    private router: Router,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private branchesService: BranchesService,
    private elRef: ElementRef,
    private filesService: FilesService,
    private overlay: Overlay,
    private cdr: ChangeDetectorRef,
    private usersService: UsersService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) {
    if (localStorage.getItem('printingService') === 'ph') {
      this.router.navigate(['/phprint']);
    }

    this.translateService.onLangChange.subscribe(() => {
      this.lang = this.translateService.currentLang
        ? this.translateService.currentLang
        : 'he';
    });

    this.trackUploadProgress();
  }

  // ngOnInit ---------------------------------------------------------------
  async ngOnInit() {
    this.isToRefreshTable = true;
    this.isLoading = true;

    // Track if this is the first direction change (initial load)
    let isFirstDirectionChange = true;

    this.directionSubscription = this.directionService.direction$.subscribe(
      (direction) => {
        const previousIsRTL = this.isRTL;
        this.isRTL = direction === 'rtl';
        this.tooltipDirection = this.isRTL ? 'rtl' : 'ltr';
        
        // If direction changed and component is already initialized, update preview
        if (!isFirstDirectionChange && previousIsRTL !== this.isRTL) {
          // Use setTimeout to ensure DOM is ready after direction change
          setTimeout(() => {
            if (this.printingService === 'plotter' && this.currentImage) {
              this.updatePreview();
            } else if (this.printingService === 'express' && this.currentFile) {
              this.updatePreviewExpress();
            }
          }, 0);
        }
        isFirstDirectionChange = false;
      }
    );

    this.directionService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });

    try {
      this.branches = await this.branchesService.getAllBranches().toPromise();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error fetching and transforming branches:', error);
    }

    this.dialogService.closeResizeDialog$.subscribe(() => {
      this.checkReturnedResizedFile();
    });

    this.previousTotalOrderdFixProductsPrice =
      this.totalOrderdFixProductsPrice();

    this.previewDialogSubscription =
      this.dataSharingService.triggerOpenPreviewDialog$.subscribe(() => {
        this.openPreviewDialog();
      });

    this.dataSharingService.fixProductsOrderCreated$.subscribe(() => {
      this.clearFixProducts();
    });

    // ProcessingFile Dialog
    this.dialogService.closeProcessingFileDialog$.subscribe(() => {
      this.isProcessingFileDialogOpen = false;
    });
    if (localStorage.getItem('nopfa')) {
      const nopfa = localStorage.getItem('nopfa');
      const nopfaNumber = parseInt(nopfa, 10);
      if (nopfaNumber > 0) {
        this.NumOfProcessingFileAlert = nopfaNumber;
      }
    }
    setTimeout(() => {
      this.isProcessingFileDialogOpen = false;
    }, 3000);
    // // ProcessingFile Dialog

    if (localStorage.getItem('borderDialog') === 'true') {
      this.isBorderDialogOpened = true;
    }

    // the user may be fetched before verifying a phone (phone dialog opened over the table)
    this.phoneUpdatedSub = this.usersService.phoneUpdated.subscribe(
      (phone: number) => {
        if (this.user) {
          this.user.phone = phone;
        }
      }
    );

    this.branchSubscription = this.dataSharingService.getBranch().subscribe(
      async (value) => {
        if (!value) {
          if (
            localStorage.getItem('printingService') &&
            localStorage.getItem('branch') &&
            localStorage.getItem('printingService') !== '' &&
            localStorage.getItem('branch') !== ''
          ) {
            const service = localStorage.getItem('printingService');
            const branch = localStorage.getItem('branch');
            await this.dataSharingService.setPrintingService(service);
            await this.dataSharingService.setBranch(branch);
            this.printingService = service;
            this.branch = branch;
            this.isCloseStatusInformed = false;
          } else {
            this.reloadTable();
          }
        }
        // clear previous interval
        this.clearMainInterval();
        this.isLoading = true;

        window.addEventListener('beforeunload', this.beforeUnloadHandler);

        // get printing service
        this.printingServiceSubscription = this.dataSharingService
          .getPrintingService()
          .subscribe(
            (value) => {
              if (value === 'express' || value === 'plotter') {
                this.printingService = value;
                this.resetValues();
                this.isCloseStatusInformed = false;
              } else {
                this.router.navigate(['/']);
              }
            },
            (error) => {
              this.router.navigate(['/']);
            }
          );

        // get branch
        if (
          this.branches &&
          this.branches.find((branch) => branch.name === value)
        ) {
          this.branch = value;
          this.branchID = this.branches.find((branch) => branch.name === value)[
            this.printingService
          ].branch;
          this.realBranch = this.branches.find(
            (branch) => branch.name === value
          );
          
          // Reset isCloseStatusInformed when switching branches/printers
          // This ensures the dialog opens every time we enter the page or switch to a closed branch/printer
          this.isCloseStatusInformed = false;
          this.skipRasterize = false;
          this.forceRasterize = false;
          this.clearMainInterval();
          // Reset message button state
          this.showMessageButton = false;
          
          // Cancel existing message button timeout if any
          if (this.messageButtonTimeout) {
            clearTimeout(this.messageButtonTimeout);
            this.messageButtonTimeout = null;
          }
          
          if (this.printingService === 'plotter') {
            await this.handlePlotterPrintingService();
          } else if (this.printingService === 'express') {
            await this.handleExpressPrintingService();
          }
          await this.initializeFileUploader();
          this.startOrStopAnimateNoPaper();
          this.startOrStopAnimateUploadSVG();
          // Add timeout to ensure page is fully loaded before checking branch status
          setTimeout(() => {
            this.checkBranchStatus();
          }, 500);
          setTimeout(() => {
            this.playPicsDiscountAnimation();
          }, 1000);
          
          // Start checking scroll position immediately (for mobile) - only for message to customer
          // In mobile, help-and-get-points button is shown in print settings, not as floating button
          if (this.shouldShowMessageToCustomer()) {
            this.startScrollCheck();
          }
          
          // Also set timeout to show button after 5 seconds (if conditions are met) - Desktop only
          // In mobile, the help-and-get-points button is shown in print settings, so no need for timeout
          const isMobile = window.innerWidth <= 950;
          if (!isMobile) {
            this.messageButtonTimeout = setTimeout(() => {
              if (this.shouldShowMessageToCustomer() || this.shouldShowHelpAndGetPoints()) {
                // Force show after 5 seconds (even if user hasn't scrolled)
                this.checkAndShowMessageButton(true);
              }
              this.messageButtonTimeout = null;
            }, 5000);
          }
        } else {
          this.isCloseStatusInformed = true;
          const service = localStorage.getItem('printingService');
          const branch = localStorage.getItem('branch');
          if (service && branch && service !== '' && branch !== '') {
            this.printingService = service;
            this.branch = branch;
            this.dataSharingService.setPrintingService(this.printingService);
            this.dataSharingService.setBranch(this.branch);
            this.isCloseStatusInformed = false;
          } else {
            await this.router.navigate(['/']);
          }
        }
      },
      (error) => {
        this.router.navigate(['/']);
      }
    );
  }

  ngOnDestroy() {
    this.isToRefreshTable = false;
    this.phoneUpdatedSub?.unsubscribe();
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.printingServiceSubscription) {
      this.printingServiceSubscription.unsubscribe();
    }
    if (this.branchSubscription) {
      this.branchSubscription.unsubscribe();
    }
    if (this.previewDialogSubscription) {
      this.previewDialogSubscription.unsubscribe();
    }
    // Cancel message button timeout
    if (this.messageButtonTimeout) {
      clearTimeout(this.messageButtonTimeout);
      this.messageButtonTimeout = null;
    }
    this.stopScrollCheck();
    this.clearAllIntervals();
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  }

  ngDoCheck(): void {
    const currentTotalOrderdFixProductsPrice =
      this.totalOrderdFixProductsPrice();
    if (
      currentTotalOrderdFixProductsPrice !==
      this.previousTotalOrderdFixProductsPrice
    ) {
      this.previousTotalOrderdFixProductsPrice =
        currentTotalOrderdFixProductsPrice;
      this.calcTotalOrderPrice();
    }
  }

  clearAllIntervals() {
    // console.log('Clearing all intervals');
    clearInterval(this.rattleInterval);
    clearInterval(this.noPaperInterval);
    clearInterval(this.mainBtnInterval);
    clearInterval(this.isBranchCloseInterval);
    clearInterval(this.currentInterval);
    if (this.transferFilesSnackBarInterval) {
      clearTimeout(this.transferFilesSnackBarInterval);
      this.transferFilesSnackBarInterval = null;
    }
  }

  // Check if file should be hidden due to currentTransferTime
  shouldHideFileDueToTransfer(file: any): boolean {
    // If no currentTransferTime, don't hide
    if (!file.currentTransferTime) {
      return false;
    }

    // Check if currentTransferTime is a valid date
    const transferTime = new Date(file.currentTransferTime);
    if (isNaN(transferTime.getTime())) {
      // Invalid date, don't hide
      return false;
    }

    // Check if difference is less than 10 seconds
    const now = new Date();
    const diffMs = now.getTime() - transferTime.getTime();
    const diffSeconds = diffMs / 1000;

    return diffSeconds < 10 && diffSeconds >= 0;
  }

  // Show transfer files snackBar
  showTransferFilesSnackBar(file: any) {
    // Check if we can show snackBar (not shown in last 20 seconds)
    const now = Date.now();
    if (this.transferFilesSnackBarShown) {
      const timeSinceLastSnackBar = (now - this.transferFilesSnackBarTimestamp) / 1000;
      if (timeSinceLastSnackBar < 20) {
        return; // Don't show snackBar yet
      }
    }

    // Show snackBar
    // Use originalUserName if file was transferred, otherwise try to get from file.user
    const userName = file.originalUserName || file.user?.email || file.user?.name || this.translateService.instant('printing-table.user');
    const message = this.translateService.instant('printing-table.file-transferred-message', { user: userName });
    
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: ['zx-top-snackbar', 'zx-transfer-files-snackbar'],
    });

    // Mark as shown and set timestamp
    this.transferFilesSnackBarShown = true;
    this.transferFilesSnackBarTimestamp = now;

    // Clear interval after 20 seconds
    if (this.transferFilesSnackBarInterval) {
      clearInterval(this.transferFilesSnackBarInterval);
    }
    this.transferFilesSnackBarInterval = setTimeout(() => {
      this.transferFilesSnackBarShown = false;
      this.transferFilesSnackBarInterval = null;
    }, 20000);
  }

  clearMainInterval() {
    this.isChosen = false;
    if (this.currentInterval) {
      this.currentInterval.unsubscribe();
      clearInterval(this.currentInterval);
      this.currentInterval = null;
    }
  }

  async handlePlotterPrintingService(retries: number = 3) {
    // console.log('realBranch from P table:', this.realBranch);
    this.resetValues();
    this.clearPreviewDataDeep();
    this.clearPreviewData();
    // check branch and clear settings [plotter]
    if (
      !localStorage.getItem('printingService') ||
      !localStorage.getItem('branch') ||
      !localStorage.getItem('lastPrintingService') ||
      !localStorage.getItem('lastBranch') ||
      localStorage.getItem('printingService') !==
        localStorage.getItem('lastPrintingService') ||
      localStorage.getItem('branch') !== localStorage.getItem('lastBranch')
    ) {
      localStorage.setItem('branch', this.realBranch.name);
      localStorage.setItem('printingService', this.printingService);
    }
    localStorage.setItem('lastPrintingService', this.printingService);
    localStorage.setItem('lastBranch', this.branch);
    syncIsNotAcademyFromCluster(this.realBranch, 'plotter');
    // extract papers [plotter]
    this.printServicePapers = [
      ...this.realBranch.plotter.printers[0].inputBins,
    ];
    this.isLoading = false;
    this.serverAddress = this.realBranch.plotter.printers[0].serverAddress;

    try {
      if (this.printServicePapers.length > 0) {
        // === ----------------------- === update files interval [plotter] === --------------------------------------------------------- ===
        const userId = localStorage.getItem('userId');
        this.fetchUser(userId);
        this.clearMainInterval();
        this.plotterUploadErrorsShown.clear();
        this.currentInterval = interval(4000)
          .pipe(
            startWith(0),
            switchMap(() =>
              this.filesService.getUserFiles(
                userId,
                this.realBranch.plotter.printers[0]._id
              )
            )
          )
          .subscribe((response) => {
            let files = response?.files || [];
            if (!response?.files) {
              this.reloadTable();
            }

            // plotterUploadErrors – פתיחת חלונית file-issues אם יש שגיאות עיבוד
            const errors = response?.plotterUploadErrors || [];
            if (errors.length > 0) {
              const firstUnshown = errors.find((e: any) => {
                const name = e?.originalFileName || e?.fileName || '';
                return name && !this.plotterUploadErrorsShown.has(name);
              });
              if (firstUnshown) {
                const originalFileName = firstUnshown.originalFileName || firstUnshown.fileName || '';
                this.plotterUploadErrorsShown.add(originalFileName);
                const allowedExtensions = this.allowedExtensionsPlotter;
                this.dialogService.onOpenFileIssuesDialog(
                  originalFileName,
                  allowedExtensions,
                  this.phoneNumber,
                  'plotter-processing-failed',
                  {}
                );
              }
            }
            
            // Filter files with currentTransferTime (less than 10 seconds old)
            const filesToShow: any[] = [];
            const filesToHide: any[] = [];
            
            files.forEach((file) => {
              if (this.shouldHideFileDueToTransfer(file)) {
                filesToHide.push(file);
                // Show snackBar for first hidden file
                if (filesToHide.length === 1) {
                  this.showTransferFilesSnackBar(file);
                }
              } else {
                filesToShow.push(file);
              }
            });
            
            // Use filtered files
            files = filesToShow;
            
            // console.log('Fetched files:', files[1].created, Date.now(), "diff in seconds:", (Date.now() - new Date(files[1].created).getTime()) / 1000);
            // delete white pages [plotter]
            let isToDelete = true;
            files.forEach((file, fileIndex) => {
              if (file.images && file.images.length > 0) {
                isToDelete = true;
                file.images.forEach((image, imageIndex) => {
                  if (image.inkCalculation === 0 && isToDelete) {
                    isToDelete = false;
                    let whiteMsg =
                      this.translateService.instant(
                        'printing-table.white-page-deleted-multi-1'
                      ) +
                      ' ' +
                      (imageIndex + 1) +
                      ' ' +
                      this.translateService.instant(
                        'printing-table.white-page-deleted-multi-2'
                      );
                    if (file.images.length === 1) {
                      whiteMsg = this.translateService.instant(
                        'printing-table.white-page-deleted-onepage'
                      );
                    }
                    this.snackBar.open(whiteMsg, '', {
                      duration: 8000,
                      panelClass: 'zx-top-snackbar',
                    });
                    this.onDeleteFileOrImage(
                      file,
                      fileIndex,
                      image,
                      imageIndex
                    );
                  }
                });
              }
            });
            // // delete white pages [plotter]

            if (files && !this.isLoadingPreview && this.isToRefreshTable) {
              // needs to update?
              if (_.isEqual(this.files, files)) {
                // console.log('DO-NOT update -=PLOTTER=- files');
                if (this.files?.length === 0) {
                  this.clearPriceData();
                } else {
                  const now = new Date();
                  files.forEach((file, idx) => {
                    const isResizing = this.isFileResizing(file);
                    if (
                      (!file.images || file.images?.length === 0) &&
                      !isResizing
                    ) {
                      const created = new Date(file.created);
                      const now = new Date();
                      const diffMs = now.getTime() - created.getTime();
                      const diffSeconds = diffMs / 1000;
                      if (diffSeconds > this.processingFileAlertAfterSec) {
                        this.openProcessingFileDialog(file);
                      }
                    }
                  });
                }
                return;
              }
              // console.log('DO update -=PLOTTER=- files');
              // // needs to update?
              this.isLoading = true;

              if (files.length === 0) {
                this.resetValues();
                this.clearPriceData();
              } else {
                const wasFirstFileProcessing = this.wasFirstTableFileProcessing();
                this.proccessingFiles = [];
                let FirstFileIndexWithImages = 0;
                // is file found [plotter]
                let isFileFound = false;
                const now = new Date();
                files.forEach((file, idx) => {
                  const isResizing = this.isFileResizing(file);
                  if (!file.images || file.images?.length === 0 || isResizing) {
                    this.proccessingFiles.push(file);
                    if (!isResizing) {
                      const created = new Date(file.created);
                      const now = new Date();
                      const diffMs = now.getTime() - created.getTime();
                      const diffSeconds = diffMs / 1000;
                      if (diffSeconds > this.processingFileAlertAfterSec) {
                        this.openProcessingFileDialog(file);
                      }
                    }
                  } else {
                    if (!isFileFound) {
                      FirstFileIndexWithImages = idx;
                      isFileFound = true;
                    }
                    for (let image of file.images) {
                      const price = image?.price || 0;
                      if (isNaN(price)) {
                        this.currentFile = file;
                        this.currentImage = image;
                        this.onFileSettingsChange(true);
                      }
                      // Check if file just finished processing and should show weird-dpi dialog
                      if (!image.resizeProcessing) {
                        this.checkAndOpenWeirdDpiDialog(file, image);
                      }
                    }
                  }
                });
                this.closePaperTooltipIfFirstTableFileFinishedProcessing(wasFirstFileProcessing);
                this.files = files;

                this.paperCodes =
                  this.realBranch.plotter.printers[0].inputBins.map(
                    (bin) => bin.paperType.paperPrinterCode
                  );
                this.paperNames =
                  this.realBranch.plotter.printers[0].inputBins.map(
                    (bin) => bin.paperType.paperType
                  );
                if (!this.paperCodes.length || !this.paperNames.length) {
                  throw new Error('Failed to update paper codes or names');
                }
                if (
                  !this.isChosen &&
                  this.proccessingFiles.length !== this.files.length
                ) {
                  this.onChooseImage(
                    this.files[FirstFileIndexWithImages],
                    this.files[FirstFileIndexWithImages].images[0],
                    0
                  );
                  this.nextImageToSetPaper();
                  this.isScrollNeeded = true;
                } else {
                  // rechoose current image
                  if (this.currentFile && this.currentImage) {
                    const currentFileIndex = this.files.findIndex(
                      (file) => file._id === this.currentFile._id
                    );
                    const currentImageIndex = this.currentFile.images.findIndex(
                      (image) => image._id === this.currentImage._id
                    );
                    if (currentFileIndex !== -1 && currentImageIndex !== -1) {
                      this.onChooseImage(
                        this.files[currentFileIndex],
                        this.files[currentFileIndex].images[currentImageIndex],
                        currentImageIndex
                      );
                      // console.log('onChooseImage from P table 2');
                      // this.isScrollNeeded = true;
                    }
                  }
                }
                if (this.proccessingFiles.length === this.files.length) {
                  this.clearPreviewDataDeep();
                  this.clearPreviewData();
                }
              }
              this.checkIsAllFilesHavePaper();
              this.isLoading = false;
            }
          });
      }
    } catch (error) {
      console.error('Error fetching files:', error);
      if (retries > 0) {
        // console.log(`Retrying... (${3 - retries + 1})`);
        await this.handlePlotterPrintingService(retries - 1);
      } else {
        this.reloadTable();
      }
    }
  }

  openProcessingFileDialog(file: any) {
    if (
      this.printingService === 'plotter' &&
      this.NumOfProcessingFileAlert < 3 &&
      !this.isProcessingFileDialogOpen
    ) {
      if (
        file &&
        file._id &&
        !this.processingFileAlertedArray.includes(file._id)
      ) {
        this.processingFileAlertedArray.push(file._id);
        this.NumOfProcessingFileAlert++;
        localStorage.setItem('nopfa', this.NumOfProcessingFileAlert.toString());
        this.dialogService.onOpenProcessingFileDialog(
          this.printingService,
          file,
          true
        );
        this.isProcessingFileDialogOpen = true;
      }
    }
  }

  async handleExpressPrintingService(retries: number = 3) {
    // console.log('realBranch from P table:', this.realBranch);
    // console.log('realBranch from P table:', this.realBranch.express.properties.enable_crop);
    this.resetValues();
    this.clearPreviewDataDeep();
    this.clearPreviewData();
    if (
      !localStorage.getItem('printingService') ||
      !localStorage.getItem('branch') ||
      !localStorage.getItem('lastPrintingService') ||
      !localStorage.getItem('lastBranch') ||
      localStorage.getItem('printingService') !==
        localStorage.getItem('lastPrintingService') ||
      localStorage.getItem('branch') !== localStorage.getItem('lastBranch')
    ) {
      await this.onFileSettingsChangeExpress(true);
    }
    localStorage.setItem('lastPrintingService', this.printingService);
    localStorage.setItem('lastBranch', this.branch);
    syncIsNotAcademyFromCluster(this.realBranch, 'express');
    // extract papers [express]
    this.printServicePapers = this.realBranch.express?.consumables?.papers
      ? [...this.realBranch.express.consumables.papers]
      : [];
    this.isLoading = false;
    this.serverAddress = this.expressServerAdress;
    try {
      if (this.printServicePapers.length > 0) {
        // === ----------------------- === update files interval [express] === --------------------------------------------------------- ===
        const userId = localStorage.getItem('userId');
        await this.fetchUser(userId);
        this.clearMainInterval();
        this.expressUploadErrorsShown.clear();
        this.currentInterval = interval(4000)
          .pipe(
            startWith(0),
            switchMap(() =>
              this.filesService.getUserFilesExpress(
                userId,
                this.printServicePapers.length === 1
                  ? this.realBranch.express?.consumables?.papers[0]?.paperType
                  : null,
                this.realBranch.express?._id
              )
            )
          )
          .subscribe((response: { files: any[]; refreshTable?: boolean; printer?: any; expressUploadErrors?: any[] }) => {
            // expressUploadErrors – פתיחת חלונית file-issues אם יש שגיאות עיבוד
            const errors = response?.expressUploadErrors || [];
            if (errors.length > 0) {
              const firstUnshown = errors.find((e: any) => {
                const name = e?.originalFileName || e?.fileName || '';
                return name && !this.expressUploadErrorsShown.has(name);
              });
              if (firstUnshown) {
                const originalFileName = firstUnshown.originalFileName || firstUnshown.fileName || '';
                this.expressUploadErrorsShown.add(originalFileName);
                const allowedExtensions = this.allowedExtensionsExpress;
                this.dialogService.onOpenFileIssuesDialog(
                  originalFileName,
                  allowedExtensions,
                  this.phoneNumber,
                  'plotter-processing-failed',
                  {}
                );
              }
            }

            // Handle refreshTable flag from backend
            if (response.refreshTable === true && response.printer && response.printer.consumables && response.printer.consumables.papers) {
              // Check if any paper blocking status has changed
              let hasBlockingChange = false;
              let hasPaperBlocked = false; // Paper became unavailable (false -> true)
              let hasPaperUnblocked = false; // Paper became available (true -> false)
              
              if (this.realBranch && this.realBranch.express && this.realBranch.express.consumables && this.realBranch.express.consumables.papers) {
                this.realBranch.express.consumables.papers.forEach((currentPaper: any) => {
                  // Find the matching paper by serial_name from backend response
                  const matchingPaper = response.printer.consumables.papers.find(
                    (backendPaper: any) => backendPaper.serial_name === currentPaper.serial_name
                  );
                  
                  // Check if the blocking value is different
                  if (matchingPaper && currentPaper.isPreventedForUse !== matchingPaper.isPreventedForUse) {
                    hasBlockingChange = true;
                    // Check if paper was blocked (false -> true) or unblocked (true -> false)
                    if (!currentPaper.isPreventedForUse && matchingPaper.isPreventedForUse) {
                      hasPaperBlocked = true;
                    } else if (currentPaper.isPreventedForUse && !matchingPaper.isPreventedForUse) {
                      hasPaperUnblocked = true;
                    }
                  }
                });
              }
              
              // If there's a change, clear all paper settings for all files and update the papers list
              if (hasBlockingChange) {
                // Update realBranch.express with new printer data (including updated papers from backend)
                if (this.realBranch && this.realBranch.express) {
                  this.realBranch.express = {
                    ...this.realBranch.express,
                    ...response.printer,
                    consumables: {
                      ...this.realBranch.express.consumables,
                      papers: response.printer.consumables.papers
                    }
                  };
                  
                  // Update printServicePapers - include ALL papers (not filtered), like in initial load
                  // Papers with isPreventedForUse=true will be displayed but disabled
                  this.printServicePapers = this.realBranch.express.consumables.papers
                    ? [...this.realBranch.express.consumables.papers]
                    : [];
                  
                  // Update paperCodes and paperNames from all papers
                  this.paperCodes = this.realBranch.express.consumables.papers.map(
                    (paper: any) => paper.paperPrinterCode
                  );
                  this.paperNames = this.realBranch.express.consumables.papers.map(
                    (paper: any) => paper.paperType
                  );
                  
                  // Show snackbar message based on the type of change
                  // Priority: if any paper was blocked, show blocked message; otherwise show unblocked message
                  const messageKey = hasPaperBlocked 
                    ? 'printing-table.paper-blocked-update' 
                    : 'printing-table.paper-unblocked-update';
                  
                  this.snackBar.open(
                    this.translateService.instant(messageKey),
                    '',
                    {
                      duration: 8000,
                      verticalPosition: 'top',
                      panelClass: 'zx-top-snackbar'
                    }
                  );
                  
                  // Clear all print settings for all files (exact copy of what happens when switching branches)
                  // This calls clearFileSettingsExpress on the backend, which clears all file settings
                  this.onFileSettingsChangeExpress(true);
                }
              }
            }
            
            const files = response.files || [];
            if (files && !this.isLoadingPreview && this.isToRefreshTable) {
              // console.log('-=EXPRESS=- files', files);
              if (!files) {
                this.reloadTable();
              }

              // Filter files with currentTransferTime (less than 10 seconds old)
              const filesToShow: any[] = [];
              const filesToHide: any[] = [];
              
              files.forEach((file) => {
                if (this.shouldHideFileDueToTransfer(file)) {
                  filesToHide.push(file);
                  // Show snackBar for first hidden file
                  if (filesToHide.length === 1) {
                    this.showTransferFilesSnackBar(file);
                  }
                } else {
                  filesToShow.push(file);
                }
              });
              
              // Use filtered files
              const filteredFiles = filesToShow;

              filteredFiles.forEach((file) => {
                // chack paper type is valid [express]
                const currentPaper = file.printSettings?.paperType
                  ? file.printSettings.paperType
                  : null;
                if (currentPaper) {
                  const isPaperTypeValid = this.printServicePapers.some(
                    (paper) => paper.paperName === currentPaper
                  );
                  if (!isPaperTypeValid) {
                    this.onFileSettingsChangeExpress(true);
                  }
                }
                // // chack paper type is valid [express]
                file.images.forEach((image) => {
                  if (image.imagePath) {
                    image.imagePath = image.imagePath.replace(
                      /\/uploads/g,
                      this.expressServerAdress
                    );
                  }
                  if (image.inkPath) {
                    image.inkPath = image.inkPath.replace(
                      /\/uploads/g,
                      this.expressServerAdress
                    );
                  }
                  if (image.resizedPath) {
                    image.resizedPath = image.resizedPath.replace(
                      /\/uploads/g,
                      this.expressServerAdress
                    );
                  }
                  if (image.thumbnailPath) {
                    image.thumbnailPath = image.thumbnailPath.replace(
                      /\/uploads/g,
                      this.expressServerAdress
                    );
                  }
                  if (image.rotatedThumbnailPath) {
                    image.rotatedThumbnailPath =
                      image.rotatedThumbnailPath.replace(
                        /\/uploads/g,
                        this.expressServerAdress
                      );
                  }
                  // Check if file just finished processing and should show weird-dpi dialog
                  if (!image.resizeProcessing) {
                    this.checkAndOpenWeirdDpiDialog(file, image);
                  }
                });
              });

              let oldFilesForCompare = this.files;
              let newFilesForCompare = filteredFiles;

              oldFilesForCompare = oldFilesForCompare.map((order) => {
                order = _.omit(order, ['userID', 'printerID']);
                if (order.printSettings) {
                  order.printSettings = _.omit(order.printSettings, ['fit']);
                }
                return order;
              });
              newFilesForCompare = newFilesForCompare.map((order) => {
                order = _.omit(order, ['userID', 'printerID']);
                if (order.printSettings) {
                  order.printSettings = _.omit(order.printSettings, ['fit']);
                }
                return order;
              });

              // delete white pages [express]
              let isToDelete = true;
              newFilesForCompare.forEach((file, fileIndex) => {
                if (file.images && file.images.length > 0) {
                  isToDelete = true;
                  file.images.forEach((image, imageIndex) => {
                    if (image.inkLevel === 0 && isToDelete) {
                      isToDelete = false;
                      let whiteMsg =
                        this.translateService.instant(
                          'printing-table.white-page-deleted-multi-1'
                        ) +
                        ' ' +
                        (imageIndex + 1) +
                        ' ' +
                        this.translateService.instant(
                          'printing-table.white-page-deleted-multi-2'
                        );
                      if (file.images.length === 1) {
                        whiteMsg = this.translateService.instant(
                          'printing-table.white-page-deleted-onepage'
                        );
                      }
                      this.snackBar.open(whiteMsg, '', {
                        duration: 8000,
                        panelClass: 'zx-top-snackbar',
                      });
                      this.onDeleteFileOrImage(
                        file,
                        fileIndex,
                        image,
                        imageIndex
                      );
                    }
                  });
                }
              });
              // // delete white pages [express]

              if (_.isEqual(oldFilesForCompare, newFilesForCompare)) {
                if (filteredFiles?.length === 0) {
                  this.clearPriceData();
                }
                return;
              }
              this.isLoading = true;
              if (filteredFiles.length === 0) {
                this.resetValues();
                this.calcTotalOrderPrice();
              } else {
                const wasFirstFileProcessing = this.wasFirstTableFileProcessing();
                this.proccessingFiles = [];
                let FirstFileIndexWithImages = 0;
                // is file found [express]
                let isFileFound = false;
                filteredFiles.forEach((file, idx) => {
                  if (!file.images || file.images?.length === 0) {
                    this.proccessingFiles.push(file);
                  } else {
                    if (!isFileFound) {
                      FirstFileIndexWithImages = idx;
                      isFileFound = true;
                    }
                    const price = file?.price || 0;
                    if (isNaN(price)) {
                      this.currentFile = file;
                      this.currentImage = file.images[0];
                      this.onFileSettingsChangeExpress(true);
                    }
                  }
                });
                this.closePaperTooltipIfFirstTableFileFinishedProcessing(wasFirstFileProcessing);
                this.files = filteredFiles;
                // Update paperCodes and paperNames from printServicePapers (includes all papers, blocked ones are disabled)
                this.paperCodes =
                  this.printServicePapers.map(
                    (paper) => paper.paperPrinterCode
                  );
                this.paperNames =
                  this.printServicePapers.map(
                    (paper) => paper.paperType
                  );
                if (!this.paperCodes.length || !this.paperNames.length) {
                  throw new Error('Failed to update paper codes or names');
                }
                // choose first file that has images
                if (
                  !this.isChosen &&
                  this.proccessingFiles.length !== this.files.length
                ) {
                  this.onChooseImage(
                    this.files[FirstFileIndexWithImages],
                    this.files[FirstFileIndexWithImages].images[0],
                    0
                  );
                  this.nextImageToSetPaper();
                  this.isScrollNeeded = true;
                  // console.log('onChooseImage from P table 1');
                } else {
                  // rechoose the current image
                  if (this.currentFile && this.currentImage) {
                    const currentFileIndex = this.files.findIndex(
                      (file) => file._id === this.currentFile._id
                    );
                    const currentImageIndex = this.currentFile.images.findIndex(
                      (image) => image._id === this.currentImage._id
                    );
                    if (currentFileIndex !== -1 && currentImageIndex !== -1) {
                      this.onChooseImage(
                        this.files[currentFileIndex],
                        this.files[currentFileIndex].images[currentImageIndex],
                        currentImageIndex
                      );
                      // this.isScrollNeeded = true;
                      // console.log('onChooseImage from P table 2');
                    }
                  }
                }
                if (this.proccessingFiles.length === this.files.length) {
                  this.clearPreviewDataDeep();
                  this.clearPreviewData();
                }
              }
              this.checkIsAllFilesHavePaper();
              this.isLoading = false;
            }
          });
      }
    } catch (error) {
      console.error('Error fetching files:', error);
      if (retries > 0) {
        // console.log(`Retrying... (${3 - retries + 1})`);
        await this.handleExpressPrintingService(retries - 1);
      } else {
        this.reloadTable();
      }
    }
  }

  reloadTable() {
    // console.log('Reloading table...');
    this.clearAllIntervals();
    if (
      localStorage.getItem('printingService') &&
      localStorage.getItem('branch')
    ) {
      this.router.navigate([
        '/qr/' +
          localStorage.getItem('printingService') +
          '/' +
          localStorage.getItem('branch'),
      ]);
    } else {
      this.router.navigate(['/']);
    }
  }

  checkBranchStatus() {
    // Check if realBranch is ready
    if (!this.realBranch) {
      // If realBranch is not ready, try again after a short delay
      setTimeout(() => {
        this.checkBranchStatus();
      }, 300);
      return;
    }

    if (this.printingService === 'plotter') {
      if (this.realBranch?.plotter?.close) {
        if (!this.isCloseStatusInformed) {
          const branchId = this.realBranch?.plotter?._id || null;
          this.dialogService.onOpenCloseBranchDialog(
            this.printingService,
            this.branch,
            this.realBranch.plotter.close_msg,
            false,
            branchId
          );
          this.isCloseStatusInformed = true;
        }
      }
    } else if (this.printingService === 'express') {
      if (this.realBranch?.express?.properties?.close) {
        if (!this.isCloseStatusInformed) {
          const branchId = this.realBranch?.express?._id || null;
          this.dialogService.onOpenCloseBranchDialog(
            this.printingService,
            this.branch,
            this.realBranch.express.properties.close_msg,
            this.isPicsPrinter(),
            branchId
          );
          this.isCloseStatusInformed = true;
        }
      }
    }
    this.isBranchCloseInterval = setInterval(async () => {
      if (!this.isCloseStatusInformed) {
        try {
          let service = localStorage.getItem('printingService');
          let branch = localStorage.getItem('branch');
          const status = await this.branchesService
            .onCheckBranchStatus(service, branch)
            .toPromise();
          if (status.status?.close) {
            if (!this.isCloseStatusInformed) {
              // Get branch ID based on printing service
              let branchId: string = null;
              if (this.printingService === 'plotter' && this.realBranch?.plotter?._id) {
                branchId = this.realBranch.plotter._id;
              } else if (this.printingService === 'express' && this.realBranch?.express?._id) {
                branchId = this.realBranch.express._id;
              }
              this.dialogService.onOpenCloseBranchDialog(
                this.printingService,
                this.realBranch.name,
                status.status.close_msg,
                this.isPicsPrinter(),
                branchId
              );
              this.isCloseStatusInformed = true;
            }
          } else {
            this.isCloseStatusInformed = false;
          }
        } catch (error) {
          console.error('Error fetching branch status:', error);
        }
      }
    }, 30000);
  }

  // Get message to customer for current branch
  getMessageToCustomer(): any {
    if (!this.realBranch || !this.printingService) {
      return null;
    }
    
    if (this.printingService === 'plotter' && this.realBranch.plotter?.messageToCustomer) {
      return this.realBranch.plotter.messageToCustomer;
    } else if (this.printingService === 'express' && this.realBranch.express?.messageToCustomer) {
      return this.realBranch.express.messageToCustomer;
    }
    
    return null;
  }

  // Check if message exists (without localStorage check)
  hasMessageToCustomer(): boolean {
    const message = this.getMessageToCustomer();
    return message && message.isOn;
  }

  // Check if message should be displayed
  shouldShowMessageToCustomer(): boolean {
    const message = this.getMessageToCustomer();
    if (!message || !message.isOn) {
      return false;
    }
    
    // Check if user dismissed this specific message
    const dismissedTitle = localStorage.getItem('messageToCustomer');
    if (dismissedTitle && dismissedTitle === message.title) {
      return false;
    }
    
    return true;
  }

  // Close message button
  closeMessageButton(): void {
    const message = this.getMessageToCustomer();
    if (message && message.title) {
      localStorage.setItem('messageToCustomer', message.title);
    }
    this.showMessageButton = false;
    // Force immediate update so fullscreen button appears right away
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  // Open message to customer view dialog
  openMessageToCustomerViewDialog(): void {
    const message = this.getMessageToCustomer();
    if (message) {
      // Save dismissal to localStorage (same as X button)
      if (message.title) {
        localStorage.setItem('messageToCustomer', message.title);
      }
      // Hide the button
      this.showMessageButton = false;
      // Open the dialog with state 'messageToCustomer'
      this.dialogService.onOpenMessageToCustomerViewDialog(message, 'messageToCustomer');
    }
  }

  // Check if help and get points message should be displayed
  shouldShowHelpAndGetPoints(): boolean {
    // Show if there's no message to customer (available to all users)
    if (this.hasMessageToCustomer()) {
      return false;
    }
    
    // Check if branch/printer is marked as not academy - if so, don't show the message
    if (this.printingService === 'express' && this.realBranch?.express?.properties?.isNotAcademy) {
      return false;
    }
    if (this.printingService === 'plotter' && (this.realBranch?.isNotAcademy || this.realBranch?.plotter?.isNotAcademy)) {
      return false;
    }
    
    // dismissed = הצטרף לקבוצה – הכפתור לא יופיע לצמיתות. timestamp = הכפתור לא יופיע 48 שעות.
    const stored = localStorage.getItem('messageToHelpPt');
    if (stored === 'dismissed') {
      return false;
    }
    if (stored) {
      const timestamp = Number(stored);
      if (!isNaN(timestamp) && (Date.now() - timestamp) < 48 * 60 * 60 * 1000) {
        return false;
      }
    }
    return true;
  }

  // Close help and get points button – שומר זמן נוכחי (לא dismissed)
  closeHelpAndGetPointsButton(): void {
    localStorage.setItem('messageToHelpPt', String(Date.now()));
    this.showMessageButton = false;
    // Force immediate update so fullscreen button appears right away
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  // Open help and get points dialog (when no message to customer)
  openHelpAndGetPointsDialog(): void {
    // Get branch/printer ID based on printing service
    // For plotter: use branch ID (realBranch.plotter._id)
    // For express: use printer ID (realBranch.express._id)
    let branchOrPrinterId: string = null;
    if (this.printingService === 'plotter' && this.realBranch?.plotter?._id) {
      branchOrPrinterId = this.realBranch.plotter._id;
    } else if (this.printingService === 'express' && this.realBranch?.express?._id) {
      branchOrPrinterId = this.realBranch.express._id;
    }
    
    // Open the same dialog as message to customer, but with state 'messageToHelpPt'
    this.dialogService.onOpenMessageToCustomerViewDialog(null, 'messageToHelpPt', this.printingService, branchOrPrinterId);
  }

  // Check if message button should be shown (for mobile - only if user scrolled or content is long)
  // Note: In mobile, help-and-get-points button is shown in print settings, not as floating button
  checkAndShowMessageButton(forceShow: boolean = false): void {
    // On mobile, only show floating button for message-to-customer (not for help-and-get-points)
    if (window.innerWidth <= 950) { // Mobile (up to 950px)
      // Only show floating button for message-to-customer
      if (!this.shouldShowMessageToCustomer()) {
        return;
      }
      
      if (forceShow) {
        // Force show (e.g., after 5 seconds timeout)
        this.showMessageButton = true;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        return;
      }
      
      const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show if user scrolled at least 100px OR if content is long enough (more than 1.5x viewport)
      if (scrollY > 100 || documentHeight > windowHeight * 1.5) {
        this.showMessageButton = true;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }
    } else {
      // Desktop - show immediately
      this.showMessageButton = true;
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }
  }

  // Start checking scroll position periodically (for mobile)
  startScrollCheck(): void {
    // Clear existing interval if any
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
    }
    
    // Only check on mobile (up to 950px)
    if (window.innerWidth <= 950) {
      this.scrollCheckInterval = setInterval(() => {
        // Stop checking if button is already shown
        if (this.showMessageButton) {
          this.stopScrollCheck();
          return;
        }
        
        // Only check if conditions are met - in mobile, only check for message-to-customer
        // (help-and-get-points button is shown in print settings, not as floating button)
        if (this.shouldShowMessageToCustomer()) {
          this.checkAndShowMessageButton();
          // Stop checking if button was shown
          if (this.showMessageButton) {
            this.stopScrollCheck();
          }
        }
      }, 500); // Check every 500ms
    }
  }

  // Stop checking scroll position
  stopScrollCheck(): void {
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
      this.scrollCheckInterval = null;
    }
  }

  async initializeFileUploader() {
    if (this.uploadingFiles.length > 0) {
      this.stopUploading();
    }
    this.endpoint = `${this.serverAddress}/api/files/upload`;
    this.uploader.setOptions({ url: this.endpoint });
  }

  stopUploading() {
    this.uploader.cancelAll();
    this.uploadingFiles = [];
    this.uploadProgress = 0;
    this.currentlyUploading = false;
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }

  // [general]
  async fetchUser(userId: string) {
    if (!userId || userId === '') {
      console.error('User ID is not available in local storage.');
      this.authService.logout();
      return;
    }
    try {
      this.user = await this.usersService.getUser(userId).toPromise();
    } catch (error) {
      console.error('Error fetching user:', error);
    }
    // console.log('USER object is HERE', this.user);
  }

  // [plotter + express]
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.printingService === 'plotter') {
      this.updatePreview();
    } else if (this.printingService === 'express') {
      this.updatePreviewExpress();
    }
    
    // Handle breakpoint change for Help and Get Points button (950px)
    this.handleBreakpointChange();
  }
  
  // Handle breakpoint change for Help and Get Points button
  handleBreakpointChange(): void {
    const isMobile = window.innerWidth <= 950;
    
    // If we're on desktop (above 950px) and conditions are met, show the button
    if (!isMobile) {
      // Desktop mode - show floating button if conditions are met
      if (this.shouldShowMessageToCustomer() || this.shouldShowHelpAndGetPoints()) {
        // Stop scroll check if it's running (mobile only)
        this.stopScrollCheck();
        
        // Show button immediately on desktop
        if (this.shouldShowMessageToCustomer() || (!this.hasMessageToCustomer() && this.shouldShowHelpAndGetPoints())) {
          this.checkAndShowMessageButton(true);
        }
      }
    } else {
      // Mobile mode (up to 950px)
      // Stop any desktop timeout if running
      if (this.messageButtonTimeout) {
        clearTimeout(this.messageButtonTimeout);
        this.messageButtonTimeout = null;
      }
      
      // For mobile, only show floating button for message-to-customer
      // Help-and-get-points button is shown in print settings
      if (this.shouldShowMessageToCustomer()) {
        this.startScrollCheck();
      } else {
        // If we don't need to show message button, hide it
        this.showMessageButton = false;
        this.stopScrollCheck();
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }
    }
  }

  // IMAGE PREVIEW

  // === ----------------------- === [plotter] IMAGE PREVIEW === --------------------------------------------------------- ===

  updatePreview(): void {
    this.isLoadingPreview = true;

    // Get paper + image containers
    const previewPaper: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-paper');
    const previewImageContainer: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-image-container');
    if (!previewPaper || !previewImageContainer) {
      return;
    }

    // Reset dimensions
    // Paper
    previewPaper.style.width = `0px`;
    previewPaper.style.height = `0px`;
    // Image
    previewImageContainer.style.width = `0px`;
    previewImageContainer.style.height = `0px`;

    // Get container dimensions
    const previewContainer: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-container');

    // Get upper dim
    const upperDim1: HTMLElement =
      this.elRef.nativeElement.querySelector('#upperDim1');
    const upperDim2: HTMLElement =
      this.elRef.nativeElement.querySelector('#upperDim2');
    const upperDim3: HTMLElement =
      this.elRef.nativeElement.querySelector('#upperDim3');

    this.previewContainerWidth = previewContainer.offsetWidth;
    this.previewContainerHeight = previewContainer.offsetHeight;

    // Get paper width
    if (
      this.currentImage &&
      this.currentPrintSettings &&
      this.printServicePapers.some(
        (paper) => paper.paperType.paperPrinterCode === this.currentPaperType
      )
    ) {
      this.selectedPaper = this.printServicePapers.find(
        (paper) => paper.paperType.paperPrinterCode === this.currentPaperType
      );
    }

    if (this.selectedPaper) {
      // Set paper width
      this.currentPaperWidth = this.selectedPaper.paperType.paperWidth / 1000;

      // margin?
      if (this.cmFromTopValue) {
        this.currentPaperMargin = 1;
      } else {
        this.currentPaperMargin = 0;
      }

      // Calculate if needs to rotate 1
      let BeforeRotationImageWidth = 0;
      let BeforeRotationImageHeight = 0;
      if (this.currentPaperType) {
        BeforeRotationImageWidth = (this.currentImage.imageWidth / 300) * 2.54;
        BeforeRotationImageHeight =
          (this.currentImage.imageHeight / 300) * 2.54;
      }

      // boat dims are too big
      if (
        BeforeRotationImageWidth >= this.currentPaperWidth &&
        BeforeRotationImageHeight >= this.currentPaperWidth
      ) {
        // console.log("file is too bog for the this.paperCodes, need to resize! 2");
        this.resizedInagePrintSettings = this.currentPrintSettings;
        this.openResizeDialog(true);
        this.onFileSettingsChange(true);
        return;
      }

      // Calculate if needs to rotate 2
      if (
        BeforeRotationImageWidth >= this.currentPaperWidth ||
        BeforeRotationImageHeight >= this.currentPaperWidth
      ) {
        // 1 dim are too big
        if (BeforeRotationImageWidth > BeforeRotationImageHeight) {
          // width is bigger
          this.isCurrentrotated = true;
          this.currentImageWidth = BeforeRotationImageHeight;
          this.currentImageHeight = BeforeRotationImageWidth;
        } else {
          // height is bigger
          this.isCurrentrotated = false;
          this.currentImageWidth = BeforeRotationImageWidth;
          this.currentImageHeight = BeforeRotationImageHeight;
        }
      } else {
        // 2 dim are NOT too big
        if (BeforeRotationImageWidth > BeforeRotationImageHeight) {
          // width is bigger
          this.isCurrentrotated = false;
          this.currentImageWidth = BeforeRotationImageWidth;
          this.currentImageHeight = BeforeRotationImageHeight;
        } else {
          // height is bigger
          this.isCurrentrotated = true;
          this.currentImageWidth = BeforeRotationImageHeight;
          this.currentImageHeight = BeforeRotationImageWidth;
        }
      }

      this.currentPaperHeight =
        this.currentImageHeight + this.currentPaperMargin;

      // Calc dimantion of maximal preview size
      if (
        this.previewContainerHeight / this.previewContainerWidth >
        this.currentPaperHeight / this.currentPaperWidth
      ) {
        // fit to width
        this.factor = this.previewContainerWidth / this.currentPaperWidth;
        this.previewPaperWidth = this.previewContainerWidth;
        this.previewPaperHeight = this.currentPaperHeight * this.factor;
        this.previewImageContainerWidth = this.currentImageWidth * this.factor;
        this.previewImageContainerHeight =
          this.currentImageHeight * this.factor;
      } else {
        // fit to height
        this.factor = this.previewContainerHeight / this.currentPaperHeight;
        this.previewPaperHeight = this.previewContainerHeight;
        this.previewPaperWidth = this.currentPaperWidth * this.factor;
        this.previewImageContainerHeight =
          this.currentImageHeight * this.factor;
        this.previewImageContainerWidth = this.currentImageWidth * this.factor;
      }

      // rotated ?
      if (!this.isCurrentrotated) {
        // not rotated
        this.previewImageWidth = this.previewImageContainerWidth;
        this.previewImageHeight = this.previewImageContainerHeight;
      } else {
        // rotated
        this.previewImageWidth = this.previewImageContainerHeight;
        this.previewImageHeight = this.previewImageContainerWidth;
      }
    } else {
      this.clearPreviewData();
    }
    this.isLoadingPreview = false;

    // === Update borders ===
    const previewPaperOverlay: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-paper-overlay');
    previewImageContainer.style.borderTop = `unset`;
    previewImageContainer.style.borderBottom = `unset`;
    previewImageContainer.style.borderLeft = `unset`;
    previewImageContainer.style.borderRight = `unset`;
    previewImageContainer.style.left = '';
    previewImageContainer.style.top = '';
    const borderPX = this.borderCM * this.factor;
    previewPaperOverlay.style.border = `solid ${borderPX}px white`;
    // === Update borders ===

    // Update paper dimensions
    previewPaper.style.width = `${this.previewPaperWidth}px`;
    previewPaper.style.height = `${this.previewPaperHeight}px`;

    // Update img dimensions
    previewImageContainer.style.width = `${this.previewImageWidth}px`;
    previewImageContainer.style.height = `${this.previewImageHeight}px`;

    // Update dims preview dimensions
    if (!this.centerValue) {
      // if NOT centered
      upperDim1.style.width = `${
        this.previewPaperWidth - this.previewImageContainerWidth
      }px`;
      upperDim2.style.width = `${this.previewImageContainerWidth}px`;
      upperDim3.style.width = `0px`;
    } else {
      // if centered
      upperDim1.style.width = `${
        (this.previewPaperWidth - this.previewImageContainerWidth) / 2
      }px`;
      upperDim2.style.width = `${this.previewImageContainerWidth}px`;
      upperDim3.style.width = `${
        (this.previewPaperWidth - this.previewImageContainerWidth) / 2
      }px`;
    }

    // price calculation
    this.totalOrderPrice = 0;
    this.totalOrderPriceBeforeDiscount = 0;
    this.calcTotalOrderPrice();
  }

  // === ----------------------- === [express] IMAGE PREVIEW === --------------------------------------------------------- ===

  updatePreviewExpress(isToUpdateFit: boolean = false): void {
    this.isLoadingPreview = true;

    // Get paper + image containers
    const previewPaper: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-paper');
    const previewPaperOverlay: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-paper-overlay');
    const previewImageContainer: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-image-container');
    if (!previewPaper || !previewImageContainer) {
      return;
    }

    // Reset dimensions
    // Paper
    previewPaper.style.width = `0px`;
    previewPaper.style.height = `0px`;
    previewPaperOverlay.style.border = `unset`;
    // Image
    previewImageContainer.style.width = `0px`;
    previewImageContainer.style.height = `0px`;

    // Get container dimensions
    const previewContainer: HTMLElement =
      this.elRef.nativeElement.querySelector('#preview-container');

    // Get upper dim
    const upperDim1: HTMLElement =
      this.elRef.nativeElement.querySelector('#upperDim1');
    const upperDim2: HTMLElement =
      this.elRef.nativeElement.querySelector('#upperDim2');
    const upperDim3: HTMLElement =
      this.elRef.nativeElement.querySelector('#upperDim3');
    // Get sider dim
    const siderDim1: HTMLElement =
      this.elRef.nativeElement.querySelector('#siderDim1');
    const siderDim2: HTMLElement =
      this.elRef.nativeElement.querySelector('#siderDim2');
    const siderDim3: HTMLElement =
      this.elRef.nativeElement.querySelector('#siderDim3');

    this.previewContainerWidth = previewContainer.offsetWidth;
    this.previewContainerHeight = previewContainer.offsetHeight;

    // Get paper width
    if (
      this.currentImage &&
      this.currentPrintSettings &&
      this.printServicePapers.find(
        (paper) => paper.paperName === this.currentPrintSettings.paperType
      )
    ) {
      this.selectedPaper = this.printServicePapers.find(
        (paper) => paper.paperName === this.currentPrintSettings.paperType
      );
    }
    if (
      this.selectedPaper &&
      this.currentImage?.imageWidth &&
      this.currentImage?.origImageDPI &&
      this.currentImage?.imageHeight
    ) {
      // console.log('updatePreviewExpress 4', this.selectedPaper);
      const paperType = this.selectedPaper.paperType;
      if (paperType === 'A4') {
        this.currentPaperWidth = 21;
        this.currentPaperHeight = 29.7;
      } else if (paperType === 'A3') {
        this.currentPaperWidth = 29.7;
        this.currentPaperHeight = 42;
      } else if (paperType === 'CY-SM') {
        this.currentPaperWidth = 10.16;
        this.currentPaperHeight = 15.24;
      } else if (paperType === 'CY-MD') {
        this.currentPaperWidth = 12.7;
        this.currentPaperHeight = 17.78;
      } else if (paperType === 'CY-LG') {
        this.currentPaperWidth = 15.24;
        this.currentPaperHeight = 20.32;
      }

      // Calculate if needs to rotate 1
      let BeforeRotationImageWidth =
        (this.currentImage.imageWidth / this.currentImage.origImageDPI) * 2.54;
      let BeforeRotationImageHeight =
        (this.currentImage.imageHeight / this.currentImage.origImageDPI) * 2.54;

      // Calculate bigest dims of all images
      let BeforeRotationAllImagesBiggestWidth = this.currentFile.images.reduce(
        (max, image) => {
          return Math.max(max, (image.imageWidth / image.origImageDPI) * 2.54);
        },
        0
      );
      let BeforeRotationAllImagesBiggestHeight = this.currentFile.images.reduce(
        (max, image) => {
          return Math.max(max, (image.imageHeight / image.origImageDPI) * 2.54);
        },
        0
      );

      // printer margins (if defined) reduce the area the image can occupy
      const printableArea = this.getExpressPrintableArea(
        this.currentPaperWidth,
        this.currentPaperHeight
      );
      const printableWidth = printableArea.width;
      const printableHeight = printableArea.height;

      const biggerPaperDimm = Math.max(printableWidth, printableHeight);
      const smallerPaperDimm = Math.min(printableWidth, printableHeight);

      // check if original size is possible
      if (
        (biggerPaperDimm > BeforeRotationAllImagesBiggestWidth &&
          smallerPaperDimm > BeforeRotationAllImagesBiggestHeight) ||
        (biggerPaperDimm > BeforeRotationAllImagesBiggestHeight &&
          smallerPaperDimm > BeforeRotationAllImagesBiggestWidth)
      ) {
        // original size is possible
        // console.log('original size is possible !!');
        this.isFitRequired = false;
      } else {
        // original size is NOT possible
        // console.log('original size is NOT possible !!');
        this.fitValue = true;
        this.isFitRequired = true;
        if (isToUpdateFit) {
          this.updateFitFileExpress();
        }
      }

      if (this.fitValue) {
        // do fit
        // console.log('do fit !!');
        let factorIfNotRotater;
        let factorIfRotater;
        if (
          BeforeRotationImageWidth / printableWidth >
          BeforeRotationImageHeight / printableHeight
        ) {
          factorIfNotRotater = BeforeRotationImageWidth / printableWidth;
          // console.log("factorIfNotRotater 01", factorIfNotRotater);
        } else {
          factorIfNotRotater = BeforeRotationImageHeight / printableHeight;
          // console.log("factorIfNotRotater 02", factorIfNotRotater);
        }
        if (
          BeforeRotationImageWidth / printableHeight >
          BeforeRotationImageHeight / printableWidth
        ) {
          factorIfRotater = BeforeRotationImageWidth / printableHeight;
          // console.log("factorIfRotater 03", factorIfRotater);
        } else {
          factorIfRotater = BeforeRotationImageHeight / printableWidth;
          // console.log("factorIfRotater 04", factorIfRotater);
        }

        if (factorIfRotater < factorIfNotRotater) {
          // do rotate
          // console.log('do rotate !!');
          this.isCurrentrotated = true;
          const AfretRotationImageWidth = BeforeRotationImageHeight;
          const AfretRotationImageHeight = BeforeRotationImageWidth;
          if (
            printableWidth / AfretRotationImageWidth <
            printableHeight / AfretRotationImageHeight
          ) {
            // fit to width
            // console.log('fit to width !!');
            this.scaleImageFactor = printableWidth / AfretRotationImageWidth;
            this.currentImageHeight =
              AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth =
              AfretRotationImageWidth * this.scaleImageFactor;
          } else {
            // fit to height
            // console.log('fit to height !!');
            this.scaleImageFactor = printableHeight / AfretRotationImageHeight;
            this.currentImageHeight =
              AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth =
              AfretRotationImageWidth * this.scaleImageFactor;
          }
        } else {
          // dont rotate
          // console.log('dont rotate !!');
          this.isCurrentrotated = false;
          const AfretRotationImageWidth = BeforeRotationImageWidth;
          const AfretRotationImageHeight = BeforeRotationImageHeight;
          if (
            printableWidth / AfretRotationImageWidth <
            printableHeight / AfretRotationImageHeight
          ) {
            // fit to width
            // console.log('fit to width !!');
            this.scaleImageFactor = printableWidth / AfretRotationImageWidth;
            this.currentImageHeight =
              AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth =
              AfretRotationImageWidth * this.scaleImageFactor;
          } else {
            // fit to height
            // console.log('fit to height !!');
            this.scaleImageFactor = printableHeight / AfretRotationImageHeight;
            this.currentImageHeight =
              AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth =
              AfretRotationImageWidth * this.scaleImageFactor;
          }
        }
      } else {
        // dont fit
        // console.log('dont fit !!');
        this.scaleImageFactor = 1;
        // fit in original size and orientation?
        if (
          printableWidth > BeforeRotationImageWidth &&
          printableHeight > BeforeRotationImageHeight
        ) {
          // do fit in original size and orientation
          // console.log('do fit in original size and orientation');
          this.isCurrentrotated = false;
          this.currentImageHeight = BeforeRotationImageHeight;
          this.currentImageWidth = BeforeRotationImageWidth;
        } else {
          // doesnt fit in original size and orientation
          // console.log('doesnt fit in original size and orientation');
          this.isCurrentrotated = true;
          this.currentImageHeight = BeforeRotationImageWidth;
          this.currentImageWidth = BeforeRotationImageHeight;
        }
      }

      // Calc dimantion of maximal preview size
      if (
        this.realBranch.express?.properties?.enable_crop &&
        this.cropRatioValue
      ) {
        this.currentImageHeight = printableHeight;
        this.currentImageWidth = printableWidth;
      }

      // Calc dimantion of maximal preview size
      if (
        this.previewContainerHeight / this.previewContainerWidth >
        this.currentPaperHeight / this.currentPaperWidth
      ) {
        // fit to width
        this.factor = this.previewContainerWidth / this.currentPaperWidth;
        this.previewPaperWidth = this.previewContainerWidth;
        this.previewPaperHeight = this.currentPaperHeight * this.factor;
        this.previewImageWidth = this.currentImageWidth * this.factor;
        this.previewImageHeight = this.currentImageHeight * this.factor;
      } else {
        // fit to height
        this.factor = this.previewContainerHeight / this.currentPaperHeight;
        this.previewPaperWidth = this.currentPaperWidth * this.factor;
        this.previewPaperHeight = this.previewContainerHeight;
        this.previewImageWidth = this.currentImageWidth * this.factor;
        this.previewImageHeight = this.currentImageHeight * this.factor;
      }

      // centered?
      // this.isCurrentCenter = true;

      // B and W?
      // if (this.bwValue) {
      //   this.isCurrentBandW = true;
      // } else {
      //   this.isCurrentBandW = false;
      // }
    } else {
      this.clearPreviewData();
    }
    this.isLoadingPreview = false;

    const printerMargin = this.getExpressPrinterMarginCM();
    previewImageContainer.style.left = '';
    previewImageContainer.style.top = '';

    // === Update borders ===
    if (printerMargin) {
      previewPaperOverlay.style.border = 'unset';
      previewPaperOverlay.style.borderLeft = `solid ${printerMargin.l * this.factor}px white`;
      previewPaperOverlay.style.borderRight = `solid ${printerMargin.r * this.factor}px white`;
      previewPaperOverlay.style.borderTop = `solid ${printerMargin.t * this.factor}px white`;
      previewPaperOverlay.style.borderBottom = `solid ${printerMargin.b * this.factor}px white`;
      previewImageContainer.style.borderTop = `unset`;
      previewImageContainer.style.borderBottom = `unset`;
      previewImageContainer.style.borderLeft = `unset`;
      previewImageContainer.style.borderRight = `unset`;
    } else {
      let borderPX = this.borderCM * this.factor;
      let borderPXTopBottom = 0;
      let borderPXLeftRight = 0;
      const isWidthFitBorder =
        this.currentPaperWidth - this.currentImageWidth < this.borderCM * 2;
      const isHeightFitBorder =
        this.currentPaperHeight - this.currentImageHeight < this.borderCM * 2;
      if (this.fitValue) {
        borderPXTopBottom = borderPX;
        borderPXLeftRight = borderPX;
        if (isHeightFitBorder) {
          let newBorder =
            (this.borderCM * 2 -
              (this.currentPaperHeight - this.currentImageHeight)) /
            2;
          borderPXTopBottom = newBorder * this.factor;
          if (borderPXTopBottom < 0) {
            borderPXTopBottom = 0;
          }
        } else {
          borderPXTopBottom =
            (this.currentPaperHeight / this.currentPaperWidth) *
            this.borderCM *
            this.factor;
        }
        if (isWidthFitBorder) {
          let newBorder =
            (this.borderCM * 2 -
              (this.currentPaperWidth - this.currentImageWidth)) /
            2;
          borderPXLeftRight = newBorder * this.factor;
          if (borderPXLeftRight < 0) {
            borderPXLeftRight = 0;
          }
        } else {
          borderPXLeftRight =
            (this.currentPaperHeight / this.currentPaperWidth) *
            this.borderCM *
            this.factor;
        }
      } else {
        borderPXTopBottom = 0;
        borderPXLeftRight = 0;
        if (this.currentPaperType && (isHeightFitBorder || isWidthFitBorder)) {
          if (!this.isBorderDialogOpened) {
            this.isBorderDialogOpened = true;
            localStorage.setItem('borderDialog', 'true');
            console.log('Open border explain dialog');
            this.dialogService.onOpenBorderExplainDialog();
          }
        }
      }
      if (
        borderPX &&
        borderPX > 0 &&
        !this.realBranch.express?.properties?.enable_crop &&
        this.cropRatioValue
      ) {
        previewPaperOverlay.style.border = `solid ${borderPX}px white`;
      } else {
        previewPaperOverlay.style.border = `unset`;
      }

      if (!this.realBranch.express?.properties?.enable_crop) {
        previewImageContainer.style.borderTop = `solid ${borderPXTopBottom}px white`;
        previewImageContainer.style.borderBottom = `solid ${borderPXTopBottom}px white`;
        previewImageContainer.style.borderLeft = `solid ${borderPXLeftRight}px white`;
        previewImageContainer.style.borderRight = `solid ${borderPXLeftRight}px white`;
      } else {
        previewImageContainer.style.borderTop = `unset`;
        previewImageContainer.style.borderBottom = `unset`;
        previewImageContainer.style.borderLeft = `unset`;
        previewImageContainer.style.borderRight = `unset`;
      }
    }
    // // === Update borders ===

    // Update paper dimensions
    previewPaper.style.width = `${this.previewPaperWidth}px`;
    previewPaper.style.height = `${this.previewPaperHeight}px`;

    // Update img dimensions
    const containerWidthPX = this.isCurrentrotated
      ? this.previewImageHeight
      : this.previewImageWidth;
    const containerHeightPX = this.isCurrentrotated
      ? this.previewImageWidth
      : this.previewImageHeight;
    previewImageContainer.style.width = `${containerWidthPX}px`;
    previewImageContainer.style.height = `${containerHeightPX}px`;

    // Gaps (cm) between the image and each paper edge
    let gapLeftCM = (this.currentPaperWidth - this.currentImageWidth) / 2;
    let gapTopCM = (this.currentPaperHeight - this.currentImageHeight) / 2;
    if (printerMargin) {
      // center the image inside the printable area (paper minus margins)
      gapLeftCM =
        printerMargin.l +
        (this.currentPaperWidth -
          printerMargin.l -
          printerMargin.r -
          this.currentImageWidth) /
          2;
      gapTopCM =
        printerMargin.t +
        (this.currentPaperHeight -
          printerMargin.t -
          printerMargin.b -
          this.currentImageHeight) /
          2;
      // container is sized before rotation, so align its center with the image center
      const imageCenterXPX = (gapLeftCM + this.currentImageWidth / 2) * this.factor;
      const imageCenterYPX = (gapTopCM + this.currentImageHeight / 2) * this.factor;
      previewImageContainer.style.left = `${imageCenterXPX - containerWidthPX / 2}px`;
      previewImageContainer.style.top = `${imageCenterYPX - containerHeightPX / 2}px`;
    }
    const gapRightCM =
      this.currentPaperWidth - this.currentImageWidth - gapLeftCM;
    const gapBottomCM =
      this.currentPaperHeight - this.currentImageHeight - gapTopCM;
    // upper dims are laid out in reading direction (RTL starts from the right)
    this.previewGapStartCM = this.isRTL ? gapRightCM : gapLeftCM;
    this.previewGapEndCM = this.isRTL ? gapLeftCM : gapRightCM;
    this.previewGapTopCM = gapTopCM;
    this.previewGapBottomCM = gapBottomCM;

    upperDim1.style.width = `${this.previewGapStartCM * this.factor}px`;
    upperDim2.style.width = `${this.previewImageWidth}px`;
    upperDim3.style.width = `${this.previewGapEndCM * this.factor}px`;

    if (siderDim1 !== null && siderDim2 !== null && siderDim3 !== null) {
      siderDim1.style.height = `${gapTopCM * this.factor}px`;
      siderDim2.style.height = `${this.previewImageHeight}px`;
      siderDim3.style.height = `${gapBottomCM * this.factor}px`;
    }

    // price calculation
    this.sortedFilesArray = [];
    this.totalOrderPrice = 0;
    this.totalOrderPriceBeforeDiscount = 0;
    this.totalOrderPriceToBeforeUpdate = 0;
    this.totalOrderPriceBeforeDiscountToBeforeUpdate = 0;
    // this.imagePrintSettings$.next(this.currentPrintSettings);
    this.calcTotalOrderPrice();
  }

  // [general]
  getUserName() {
    return localStorage.getItem('userName');
  }

  // [general] Get userName for file - use originalUserName if file was transferred
  getUserNameForFile(file: any): string {
    if (file && file.originalUserName && file.originalUserName.trim() !== '') {
      // For transferred files, use the originalUserName as-is (including domain if present)
      return file.originalUserName;
    }
    return this.getUserName();
  }

  // [general] Get thumbnail URL
  getThumbnailUrl(file: any, image: any, serverAddress: string): string {
    // Use originalUserName if file was transferred, otherwise use current user name
    const userName = this.getUserNameForFile(file);
    const thumbnailFileName = image.thumbnailPath.split('/').pop();
    const thumbnailUrl = serverAddress + '/uploads/' + userName + '/' + thumbnailFileName;
    return thumbnailUrl;
  }

  // [plotter + express]
  onChooseImage(file: any, image: any, imageIndex: number) {
    // console.log('onChooseImage', image);
    // console.log('file', file);
    if (image && image.resizeProcessing) {
      return;
    }
    const hadNoImage = !this.currentImage;
    this.isLoadingPreview = true;
    this.isChosen = true;
    this.currentFile = file;
    this.currentImage = image;
    this.currentImageIndex = imageIndex;
    if (hadNoImage && image) {
      this.hidePaperTooltip();
    }
    this.currentFileIndex = this.files.findIndex((f) => f._id === file._id);
    if (!this.currentPrintSettings) {
      this.currentPrintSettings = {};
    }
    if (!this.numOfCopies) {
      this.numOfCopies = 1;
    }

    if (this.printingService === 'plotter') {
      // [plotter]
      this.updatePreview();
    } else if (this.printingService === 'express') {
      // [express]
      this.updatePreviewExpress();
    }

    this.isLoadingPreview = false;

    if (
      !this.lastFileId ||
      this.lastFileId === '' ||
      file._id !== this.lastFileId ||
      (this.printingService === 'plotter' &&
        file._id === this.lastFileId &&
        this.lastImageIndex !== imageIndex)
    ) {
      let element = document.getElementById('zx-settings-area-inner');
      if (element && this.currentImage && this.currentFile) {
        setTimeout(() => {
          if (element) element.scrollTop = 0;
        }, 0);
      }
      this.lastFileId = file._id;
      this.lastImageIndex = imageIndex;
    }

    setTimeout(() => {
      this.startOrStopAnimateNoPaper();
    }, 0);
  }

  // [plotter + express]
  getOriginalHeight(): string {
    if (this.printingService === 'plotter') {
      if (this.currentImage && this.currentImage.origImageHeight) {
        return (
          Math.ceil((this.currentImage.origImageHeight / 300) * 2.54 * 100) /
          100
        ).toFixed(2);
      }
    } else if (this.printingService === 'express') {
      if (this.currentImage && this.currentImage.imageHeight) {
        return (
          Math.ceil(
            (this.currentImage.imageHeight / this.currentImage.origImageDPI) *
              2.54 *
              100
          ) / 100
        ).toFixed(2);
      }
    }
    return '-';
  }

  // [plotter + express]
  getOriginalWidth(): string {
    if (this.printingService === 'plotter') {
      if (this.currentImage && this.currentImage.origImageWidth) {
        return (
          Math.ceil((this.currentImage.origImageWidth / 300) * 2.54 * 100) / 100
        ).toFixed(2);
      }
    } else if (this.printingService === 'express') {
      if (this.currentImage && this.currentImage.imageWidth) {
        return (
          Math.ceil(
            (this.currentImage.imageWidth / this.currentImage.origImageDPI) *
              2.54 *
              100
          ) / 100
        ).toFixed(2);
      }
    }
    return '-';
  }

  // [plotter + express]
  getActualHeight(): string {
    if (this.currentImage && this.currentImage.imageHeight) {
      if (this.printingService === 'plotter') {
        return (
          Math.ceil((this.currentImage.imageHeight / 300) * 2.54 * 100) / 100
        ).toFixed(2);
      } else if (this.printingService === 'express') {
        return (
          Math.ceil(
            ((this.currentImage.imageHeight * this.scaleImageFactor) /
              this.currentImage.origImageDPI) *
              2.54 *
              100
          ) / 100
        ).toFixed(2);
      }
    }
    return '-';
  }

  // [plotter + express]
  getActualWidth(): string {
    if (this.currentImage && this.currentImage.imageWidth) {
      if (this.printingService === 'plotter') {
        return (
          Math.ceil((this.currentImage.imageWidth / 300) * 2.54 * 100) / 100
        ).toFixed(2);
      } else if (this.printingService === 'express') {
        return (
          Math.ceil(
            ((this.currentImage.imageWidth * this.scaleImageFactor) /
              this.currentImage.origImageDPI) *
              2.54 *
              100
          ) / 100
        ).toFixed(2);
      }
    }
    return '-';
  }

  // [plotter]
  onFileSettingsChange(isToClear: boolean = false) {
    if (
      this.printingService === 'plotter' &&
      this.selectedPaperPermanent &&
      !this.isOriginalImgFitPaper(
        this.selectedPaperPermanent?.paperType?.paperPrinterCode
      )
    ) {
      this.resizedInagePrintSettings = this.currentPrintSettings;
      this.openResizeDialog(
        true,
        this.selectedPaperPermanent?.paperType?.paperWidth / 1000,
        this.selectedPaperPermanent?.paperType?.paperType
      );
      if (
        this.files[this.currentFileIndex].images[this.currentImageIndex]
          .printSettings
      ) {
        this.files[this.currentFileIndex].images[
          this.currentImageIndex
        ].printSettings.paperType = null;
      } else {
        this.files[this.currentFileIndex].images[
          this.currentImageIndex
        ].printSettings = null;
      }
      this.selectedPaperPermanent = null;
      return;
    }
    // check if fit the paper
    this.isLoadingPreview = true;
    this.limitNumOfCopies();
    this.clearPreviewData();
    if (!isToClear) {
      // settings chainge [normal]
      this.filesService
        .updateFileSettings(
          this.currentFile._id,
          this.currentImage._id,
          this.currentPrintSettings
        )
        .subscribe(
          (response) => {
            if (this.currentImage._id === response.image._id) {
              this.currentImage = response.image;
            }
            const fileIndex = this.files.findIndex(
              (file) => file._id === response.fileId
            );
            const imageIndex = this.files[fileIndex].images.findIndex(
              (image) => image._id === response.image._id
            );
            this.files[fileIndex].images[imageIndex] = response.image;
            this.updatePreview();
            this.checkIsAllFilesHavePaper();
            this.isLoadingPreview = false;
            this.startOrStopAnimateNoPaper();
          },
          (error) => {
            console.error('Error updating file settings:', error);
            if (error.error && error.error.message === 'FILE_NOT_FOUND') {
              this.reloadTable();
            }
            this.isLoadingPreview = false;
          }
        );
    } else {
      // clear settings
      this.filesService
        .updateFileSettings(this.currentFile._id, this.currentImage._id, {})
        .subscribe(
          (response) => {
            this.isLoadingPreview = false;
          },
          (error) => {
            console.error('Error updating file settings:', error);
            if (error.error && error.error.message === 'FILE_NOT_FOUND') {
              this.reloadTable();
            }
            this.isLoadingPreview = false;
          }
        );
    }
  }

  // [express]
  onFileSettingsChangeExpress(isToClear: boolean = false) {
    // find paper by this.currentPaperType
    const paper = this.printServicePapers.find(
      (paper) => paper.paperName === this.currentPrintSettings.paperType
    );
    if (paper && paper.disable_double_anyway) {
      this.currentPrintSettings.doubleSided = false;
    }

    return new Promise((resolve, reject) => {
      // console.log('---===onFileSettingsChangeExpress===---');
      this.isLoadingPreview = true;
      this.limitNumOfCopies();
      this.clearPreviewData();
      if (!isToClear) {
        // console.log('---===NOT is ToClear===---');
        // settings chainge [normal]
        this.filesService
          .updateFileSettingsExpress(
            this.currentFile._id,
            this.currentPrintSettings,
            this.realBranch.express._id
          )
          .subscribe(
            (response) => {
              if (response.file) {
                // console.log('---===response.file===---', response.file);
                if (this.currentFile._id === response.fileId) {
                  this.currentFile = response.file;
                  // find file in this.files
                  const fileIndex = this.files.findIndex(
                    (file) => file._id === response.fileId
                  );
                  this.files[fileIndex] = response.file;
                }
                this.checkIsAllFilesHavePaper();
                this.imagePrintSettings$.next(this.currentPrintSettings);
                this.isLoadingPreview = false;
                this.startOrStopAnimateNoPaper();
                this.updatePreviewExpress(true);
                this.playPicsDiscountAnimation();
              }
              this.isLoadingPreview = false;
              resolve(true);
            },
            (error) => {
              console.error('Error updating file settings:', error);
              if (error.error && error.error.message === 'FILE_NOT_FOUND') {
                this.reloadTable();
              }
              this.isLoadingPreview = false;
              reject();
            }
          );
      } else {
        // console.log('---===DO is ToClear===---');
        // clear all files settings
        this.filesService
          .clearFileSettingsExpress(localStorage.getItem('userId'))
          .subscribe(
            (response) => {
              if (response && response.updatedFiles) {
                // console.log('---===response.updatedFiles===---', response.updatedFiles);
                this.files = response.updatedFiles;
                if (this.files.length === 0) {
                  this.resetValues();
                } else {
                  this.files.forEach((file, idx) => {
                    if (file.images.length !== 0) {
                      file.printSettings = {};
                    }
                  });
                  this.paperCodes =
                    this.realBranch.express.consumables.papers.map(
                      (paper) => paper.paperPrinterCode
                    );
                  this.paperNames =
                    this.realBranch.express.consumables.papers.map(
                      (paper) => paper.paperType
                    );
                  if (!this.isChosen) {
                    this.onChooseImage(
                      this.files[0],
                      this.files[0].images[0],
                      0
                    );
                  }
                }
              }
              resolve(true);
              this.isLoadingPreview = false;
            },
            (error) => {
              console.error('Error clear files settings:', error);
              if (error.error && error.error.message === 'FILE_NOT_FOUND') {
                this.reloadTable();
              }
              reject();
              this.isLoadingPreview = false;
            }
          );
      }
    });
  }

  // [plotter + express]
  limitNumOfCopies() {
    if (this.currentPrintSettings.numOfCopies) {
      if (this.currentPrintSettings.numOfCopies < 1) {
        this.currentPrintSettings.numOfCopies = 1;
      } else if (this.currentPrintSettings.numOfCopies > 100) {
        this.currentPrintSettings.numOfCopies = 100;
        // this.snackBar.open(this.translateService.instant('printing-table.max-copies'), '', {
        //   duration: 5000,
        //   verticalPosition: 'top',
        //   panelClass: 'zx-top-snackbar'
        // });

        const snackBarRefSize = this.snackBar.open(
          this.translateService.instant('printing-table.max-copies'),
          this.translateService.instant(
            'order-complited.printed.title.sub.problme-btn'
          ),
          {
            duration: 12000,
            verticalPosition: 'top',
            panelClass: ['zx-top-snackbar', 'btn-snackbar'],
          }
        );
        snackBarRefSize.onAction().subscribe(() => {
          const message = encodeURIComponent('Big-Amount-Of-Copies-At-Eazix');
          const url = `https://wa.me/${this.phoneNumber}?text=${message}`;
          window.open(url, '_blank');
        });
      }
    } else {
      this.currentPrintSettings.numOfCopies = 1;
    }
  }

  // [express]
  updateFitFileExpress() {
    if (
      !this.currentFile?._id ||
      !this.currentPrintSettings ||
      !this.realBranch?.express?._id
    ) {
      return;
    }
    this.filesService
      .updateFileSettingsExpress(
        this.currentFile._id,
        this.currentPrintSettings,
        this.realBranch.express._id
      )
      .subscribe(
        (response) => {
          if (response.file) {
          }
        },
        (error) => {
          console.error('Error updating file settings:', error);
          this.isLoadingPreview = false;
        }
      );
  }

  // [plotter + express]
  onFileSettingsChangeBySystem() {
    if (this.printingService === 'plotter') {
      this.onFileSettingsChange();
    } else if (this.printingService === 'express') {
      this.onFileSettingsChangeExpress();
    }
  }

  // [plotter]
  isOriginalImgFitPaper(paperType: string = ''): boolean {
    // console.log('paperType paperType paperType', paperType);
    if (this.printingService !== 'plotter') {
      this.selectedPaperPermanent = null;
      return true;
    }
    const paper = this.printServicePapers.find(
      (paper) => paper.paperType.paperPrinterCode === paperType
    );
    const paperWidth = paper?.paperType.paperWidth / 1000;
    // console.log("isOriginalImgFitPaper - this.currentImage", this.currentImage);
    if (
      paperWidth &&
      this.currentImage?.imageWidth &&
      this.currentImage?.imageHeight &&
      ((this.currentImage.imageWidth / 300) * 2.54 <= paperWidth ||
        (this.currentImage.imageHeight / 300) * 2.54 <= paperWidth)
    ) {
      this.selectedPaperPermanent = paper;
      if ((this.currentImage.imageWidth / 300) * 2.54 > paperWidth) {
        this.currentImage.printSettings.isRotated = true;
        this.currentPrintSettings.isRotated = true;
      }
      return true;
    }
    // console.log('isOriginalImgFitPaper:::FALSE');
    this.selectedPaperPermanent = paper;
    return false;
  }

  isFileResizing(file: any): boolean {
    if (this.printingService !== 'plotter') {
      return false;
    }
    return file.images.some((image) => image.resizeProcessing);
  }

  // [plotter + express]
  clearPreviewData() {
    // console.log('---===clearPreviewData===---');
    this.currentPaperHeight = 0;
    this.previewImageContainerWidth = 0;
    this.previewImageContainerHeight = 0;
    this.previewImageWidth = 0;
    this.previewImageHeight = 0;
    this.previewPaperWidth = 0;
    this.previewPaperHeight = 0;
    // this.isCurrentCenter = false;
    this.currentPaperMargin = 0;
    this.previewPaperMargin = 0;
    this.factor = 0;
    // this.isCurrentBandW = false;
    this.selectedPaper = null;
    this.isAllFilesHavePaper = false;
    this.resizedInagePrintSettings = null;
    this.isFitRequired = false;
    this.scaleImageFactor = 1;
  }

  // [plotter + express]
  clearPreviewDataDeep() {
    // console.log('---===clearPreviewData **Deep** ===---');
    this.currentFile = null;
    this.currentPaperType = null;
    this.currentImage = null;
    this.currentImageIndex = null;
    this.isChosen = false;
  }

  // [plotter + express]
  resetValues() {
    // console.log('---===resetValues===---');
    this.files = [];
    this.proccessingFiles = [];
    this.paperCodes = [];
    this.paperNames = [];
    this.currentFile = null;
    this.currentImage = null;
    this.currentImageIndex = null;
    this.isChosen = false;
    this.lastFileId = '';
    this.lastImageIndex = 0;
    this.isPicsDiscountUsed = false;
  }

  // [general]
  roundDownTowDecimal(num: number): number {
    return Math.round(num * 100) / 100;
  }

  // [general]
  roundDownOneDecimal(num: number): number {
    return Math.round(num * 1000) / 10;
  }

  // [general]
  roundDownDecimal(num: number): number {
    return Math.round(num);
  }

  // paper HTML tooltips
  overlayRef: OverlayRef | null;

  // paper HTML tooltips - in printing settings
  showPaperTooltip(trigger: HTMLElement, property: string) {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(trigger)
      .withPositions([
        {
          originX: this.isRTL ? 'end' : 'start',
          originY: 'center',
          overlayX: this.isRTL ? 'start' : 'end',
          overlayY: 'center',
          offsetX: this.isRTL ? 0 : 10, // Add 10px offset to the right in LTR (English) to avoid covering the icon
        },
      ]);
    this.overlayRef = this.overlay.create({ positionStrategy });
    const tooltipPortal = new ComponentPortal(PaperTooltipContentComponent);
    const tooltipRef = this.overlayRef.attach(tooltipPortal);
    tooltipRef.instance.property = property;
    tooltipRef.instance.printingService = this.printingService;
    tooltipRef.instance.inputBins = this.realBranch.plotter?.printers[0]
      .inputBins
      ? this.realBranch.plotter.printers[0].inputBins
      : [];
    tooltipRef.instance.printServicePapers = this.printServicePapers;
    tooltipRef.instance.realBranch = this.realBranch;
  }

  hidePaperTooltip() {
    this.overlayRef?.detach();
    this.overlayRef = null;
  }

  /** True when row 0 was still in proccessingFiles before a poll rebuild. */
  private wasFirstTableFileProcessing(): boolean {
    const firstId = this.files?.[0]?._id;
    if (firstId == null) {
      return false;
    }
    return this.proccessingFiles.some((f) => f._id === firstId);
  }

  /** Desktop paper overlay survives DOM swap when row 0 leaves processing — close it. */
  private closePaperTooltipIfFirstTableFileFinishedProcessing(wasFirstProcessing: boolean): void {
    if (!wasFirstProcessing || !this.overlayRef) {
      return;
    }
    const firstId = this.files?.[0]?._id;
    if (firstId == null) {
      return;
    }
    if (!this.proccessingFiles.some((f) => f._id === firstId)) {
      this.hidePaperTooltip();
    }
  }

  // Sided Not Avaible Tooltip
  getSidedNotAvaibleTooltipText() {
    if (this.currentPaperType && this.selectedPaper) {
      if (this.currentFile?.images.length === 1) {
        return 'printing-table.explain-sided-not-avaible-one-page';
      } else if (this.isDubbleDisabledByInkLevel(this.currentFile)) {
        return 'printing-table.explain-sided-not-avaible-ink-level';
      } else if (this.isDubbleDisabledByPaper(this.selectedPaper)) {
        return 'printing-table.explain-sided-not-avaible-paper-with-no-dubble';
      } else {
        return '';
      }
    }
    return '';
  }

  isDubbleDisabledByInkLevel(file: any) {
    if (
      this.printingService === 'express' &&
      file &&
      file.images &&
      file.images.length > 0
    ) {
      let maxInkLevel = 0;
      for (let image of file.images) {
        if (image.inkLevel && image.inkLevel > maxInkLevel) {
          maxInkLevel = image.inkLevel;
        }
      }
      if (maxInkLevel > this.maxInkLevelDubble) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isDubbleDisabledByPaper(paper: any) {
    if (paper && paper.disable_double_anyway) {
      return true;
    } else {
      return false;
    }
  }

  // Maximal Not Avaible Tooltip
  getMaximalNotAvaibleTooltipText() {
    if (this.currentPaperType && this.selectedPaper && this.isFitRequired) {
      return 'printing-table.explain-original-not-avaible';
    }
    return '';
  }

  // [plotter + express]
  openPreviewDialog() {
    if (
      this.currentPrintSettings &&
      this.currentPaperType &&
      this.realBranch &&
      this.currentFile &&
      this.printingService
    ) {
      if (!this.isLoadingPreview) {
        this.openPreviewDialogInner();
      } else {
        setTimeout(() => {
          if (
            this.currentPrintSettings &&
            this.currentPaperType &&
            this.realBranch &&
            this.currentFile &&
            this.printingService &&
            !this.isLoadingPreview
          ) {
            this.openPreviewDialogInner();
          } else {
            this.animatePaperStrong();
          }
        }, 500);
      }
    } else {
      this.animatePaperStrong();
    }
  }

  openPreviewDialogInner() {
    this.dialogService.onOpenImagePreviewDialog(
      this.printingService,
      this.currentFile,
      this.currentImage,
      this.realBranch,
      this.selectedPaper,
      this.cropRatioValue
    );
  }

  // [plotter + express]
  async onDeleteFileOrImage(
    currentFile: any,
    currentFileIndex: number,
    currentImage: any,
    imageIndex: number,
    forceDeleteFile: boolean = false,
    proccessingFile: boolean = false
  ) {
    if ((this.isLoading || this.isLoadingPreview) && !forceDeleteFile) {
      return;
    }
    this.isLoading = true;
    this.isLoadingPreview = true;
    if (!proccessingFile) {
      this.onChooseImage(currentFile, currentImage, imageIndex);
    }
    try {
      // check if delete file or image
      if (this.printingService === 'plotter') {
        // [plotter]
        if (
          (currentFile.images && currentFile.images?.length === 1) ||
          forceDeleteFile
        ) {
          // delete file [plotter]
          await this.filesService
            .deleteFile(currentFile, this.serverAddress)
            .toPromise();
          const userId = localStorage.getItem('userId');
          // remove file from files
          this.files = this.files.filter(
            (file) => file._id !== currentFile._id
          );
          // remove file from proccessingFiles
          this.proccessingFiles = this.proccessingFiles.filter(
            (file) => file._id !== currentFile._id
          );
          // // update [plotter]
        } else {
          // delete image [plotter]
          await this.filesService
            .deleteImage(currentFile, currentImage, this.serverAddress)
            .toPromise();
          // remove image from this.files
          this.files[currentFileIndex].images = this.files[
            currentFileIndex
          ].images.filter((image) => image._id !== currentImage._id);
          // remove image from this.currentFile
          this.currentFile.images = this.currentFile.images?.filter(
            (image) => image._id !== currentImage._id
          );
          // // update [plotter]
        }
      } else if (this.printingService === 'express') {
        // [express]
        if (
          currentFile.images?.length === 1 ||
          forceDeleteFile ||
          proccessingFile
        ) {
          // delete file [express] *******************************
          await this.filesService
            .deleteFileExpress(currentFile, this.serverAddress)
            .toPromise();
          // remove file from files
          this.files = this.files.filter(
            (file) => file._id !== currentFile._id
          );
          // remove file from proccessingFiles
          this.proccessingFiles = this.proccessingFiles.filter(
            (file) => file._id !== currentFile._id
          );
          // // update [express]totalOrderPrice && totalOrderPriceBeforeDiscount
        } else {
          // delete image [express] *******************************
          await this.filesService
            .deleteImageExpress(currentFile, currentImage, this.serverAddress)
            .toPromise();
          // remove image from this.files
          this.files[currentFileIndex].images = this.files[
            currentFileIndex
          ].images.filter((image) => image._id !== currentImage._id);
          // remove image from this.currentFile
          this.currentFile.images = this.currentFile.images.filter(
            (image) => image._id !== currentImage._id
          );
        }
      }
      // handle plotter/express changes
      if (this.files.length === 0) {
        this.resetValues();
        this.calcTotalOrderPrice();
        if (this.totalOrderdFixProducts() > 0) {
          this.calcTotalOrderPrice();
        }
      } else {
        this.proccessingFiles = [];
        let FirstFileIndexWithImages = 0;
        let isFileFound = false;
        let isFileStillHaveImages = false;
        this.files.forEach((file, idx) => {
          const isResizing = this.isFileResizing(file);
          if (!file.images || file.images?.length === 0 || isResizing) {
            this.proccessingFiles.push(file);
          }
          let chechedFileIndex = currentFileIndex + idx;
          if (chechedFileIndex > this.files.length - 1) {
            chechedFileIndex = this.files.length - chechedFileIndex;
          }
          if (
            !isFileFound &&
            this.files[chechedFileIndex]?.images &&
            this.files[chechedFileIndex]?.images?.length > 0 &&
            !this.isFileResizing(this.files[chechedFileIndex])
          ) {
            FirstFileIndexWithImages = chechedFileIndex;
            isFileFound = true;
            if (this.currentFile?._id === this.files[chechedFileIndex]?._id) {
              isFileStillHaveImages = true;
            }
          }
        });
        // // is file found
        if (this.proccessingFiles.length !== this.files.length && isFileFound) {
          let nextImageIndex = isFileStillHaveImages
            ? this.currentImageIndex - 1
            : 0;
          if (nextImageIndex < 0) {
            nextImageIndex = 0;
          }
          this.onChooseImage(
            this.files[FirstFileIndexWithImages],
            this.files[FirstFileIndexWithImages].images[nextImageIndex],
            nextImageIndex
          );
        }
        if (this.proccessingFiles.length === this.files.length) {
          this.clearPreviewData();
          this.clearPreviewDataDeep();
          this.calcTotalOrderPrice();
        }
      }
      this.checkIsAllFilesHavePaper();
      this.isLoading = false;
      this.isLoadingPreview = false;
      setTimeout(() => {
        this.playPicsDiscountAnimation();
      }, 1000);
    } catch (error) {
      console.error('Error deleting file or image:', error);
      this.isLoading = false;
      this.isLoadingPreview = false;
    }
  }

  // [plotter + express]
  async onDeleteAllFiles() {
    if (this.isLoading || this.isLoadingPreview) {
      return;
    }
    this.isLoading = true;
    this.isLoadingPreview = true;
    try {
      if (this.printingService === 'plotter') {
        // [plotter]
        // console.log('onDeleteAllFiles plotter', this.realBranch?.plotter?.printers[0]?._id);
        await this.filesService
          .deleteAllFiles(
            this.user._id,
            this.realBranch?.plotter?.printers[0]?._id
          )
          .toPromise();
        this.resetValues();
        this.calcTotalOrderPrice();
      } else if (this.printingService === 'express') {
        // [express]
        await this.filesService
          .deleteAllFilesExpress(this.user._id)
          .toPromise();
        this.resetValues();
        this.calcTotalOrderPrice();
      }
      this.isLoading = false;
      this.isLoadingPreview = false;
    } catch (error) {
      console.error('Error deleting all files:', error);
      if (error?.error && error.error?.message === 'FILE_NOT_FOUND') {
        this.reloadTable();
      }
      this.isLoading = false;
      this.isLoadingPreview = false;
    }
  }

  // [plotter + express]
  onApplyToAll(currentPaperWidth: number, printSettings: any, paper: any) {
    this.isLoadingPreview = true;
    if (this.printingService === 'plotter') {
      // [plotter]
      let biggestDimPx = 0;
      let dpi = 300;
      if (this.files.length > 0) {
        for (let file of this.files) {
          for (let image of file.images) {
            let scale = image.scale ? image.scale : 1;
            let smallestDim = Math.min(
              image.imageHeight * scale,
              image.imageWidth * scale
            );
            biggestDimPx = Math.max(biggestDimPx, smallestDim);
          }
        }
      }
      let biggestDim = (biggestDimPx / dpi) * 2.54;
      if (biggestDim <= currentPaperWidth) {
        // console.log('can apply properties to all files!');
        this.filesService
          .applyToAll(
            this.realBranch.plotter.printers[0]._id,
            this.currentPrintSettings
          )
          .subscribe(
            (response) => {
              this.files = response.updatedFiles;
              // console.log('updatedFiles:', this.files);
              this.updatePreview();
              this.checkIsAllFilesHavePaper();
              this.isLoadingPreview = false;
              this.dialogService.onOpenApplyToAllDialog(
                this.printingService,
                true,
                this.currentPrintSettings,
                this.currentPaperWidth,
                this.currentFile,
                this.currentImageIndex,
                this.selectedPaper.paperType.paperType
              );
            },
            (error) => {
              console.error('Error updating file settings:', error);
              this.isLoadingPreview = false;
            }
          );
      } else {
        // console.log('can NOT apply properties to all files!');
        this.dialogService.onOpenApplyToAllDialog(
          this.printingService,
          false,
          this.currentPrintSettings,
          this.currentPaperWidth,
          this.currentFile,
          this.currentImageIndex,
          this.selectedPaper.paperType.paperType
        );
        this.isLoadingPreview = false;
        this.isLoading = false;
      }
    } else if (this.printingService === 'express') {
      // [express]
      // is Max Ink Level Disableing choosing paper?
      for (let file of this.files) {
        if (
          file.images &&
          file.images.length > 0 &&
          this.isMaxInkLevelDisableingFile(this.selectedPaper, file)
        ) {
          this.maxInkLevelDisableSnackBar(true);
          return;
        }
      }

      // Calculate biddest dims of all images
      this.isOriginalPossible = true;

      if (!this.fitValue) {
        // not fit
        // console.log('not fit !!');
        let maxImageWidth = 0;
        let maxImageHeight = 0;

        this.files.forEach((file) => {
          file.images.forEach((image) => {
            let dpiForCalc =
              this.printingService === 'plotter' ? 300 : image.origImageDPI;
            maxImageWidth = Math.max(
              maxImageWidth,
              (image.imageWidth / dpiForCalc) * 2.54
            );
            maxImageHeight = Math.max(
              maxImageHeight,
              (image.imageHeight / dpiForCalc) * 2.54
            );
          });
        });

        const printableArea = this.getExpressPrintableArea(
          this.currentPaperWidth,
          this.currentPaperHeight
        );
        const biggerPaperDimm = Math.max(
          printableArea.width,
          printableArea.height
        );
        const smallerPaperDimm = Math.min(
          printableArea.width,
          printableArea.height
        );

        // check if original size is possible
        if (
          (biggerPaperDimm > maxImageWidth &&
            smallerPaperDimm > maxImageHeight) ||
          (biggerPaperDimm > maxImageHeight && smallerPaperDimm > maxImageWidth)
        ) {
          // original size is possible
          // console.log('original size is possible !!');
        } else {
          // original size is NOT possible
          // console.log('original size is NOT possible !!');
          if (!this.fitValue) {
            this.isOriginalPossible = false;
          }
          this.fitValue = true;
        }
      } else {
        // do fit
        // console.log('do fit !!');
      }

      if (!this.realBranch.express?.properties?.enable_crop) {
        this.currentPrintSettings.cropRatio = false;
      }

      this.filesService
        .applyToAllExpress(
          this.currentPrintSettings,
          this.realBranch.express._id
        )
        .subscribe(
          (response) => {
            if (response && response.updatedFiles) {
              const updatedFiles = response.updatedFiles;
              this.files = updatedFiles;
              this.updatePreviewExpress();
              this.checkIsAllFilesHavePaper();
              this.isLoadingPreview = false;
              this.dialogService.onOpenApplyToAllDialog(
                this.printingService,
                this.isOriginalPossible,
                this.currentPrintSettings,
                this.currentPaperWidth,
                this.currentFile,
                this.currentImageIndex,
                this.selectedPaper.serial_name
              );
            }
          },
          (error) => {
            console.error('Error updating file settings:', error);
            this.isLoadingPreview = false;
          }
        );
    }
  }

  // next image with no paper + auto scroller -------------------------------------------------
  ngAfterViewChecked() {
    if (this.isScrollNeeded) {
      this.scrollToNextImage();
      this.isScrollNeeded = false;
    }
    if (
      this.totalOrderPrice !== this.totalOrderPriceToBeforeUpdate &&
      this.printingService === 'express'
    ) {
      this.totalOrderPrice = this.totalOrderPriceToBeforeUpdate;
      this.cdr.detectChanges();
    }
    if (
      this.totalOrderPriceBeforeDiscount !==
        this.totalOrderPriceBeforeDiscountToBeforeUpdate &&
      this.printingService === 'express'
    ) {
      this.totalOrderPriceBeforeDiscount =
        this.totalOrderPriceBeforeDiscountToBeforeUpdate;
      this.cdr.detectChanges();
    }
    if (this.branchHasFixProducts()) {
      this.fixProductsTotalPrice = this.fixProductsTotalPriceToBeforeUpdate;
      this.cdr.detectChanges();
    }
  }

  // [plotter + express]
  nextImageToSetPaper(isFromResize: boolean = false): void {
    this.isAllFilesHavePaper = true;
    if (this.printingService === 'plotter') {
      // [plotter]
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        for (let j = 0; j < file.images.length; j++) {
          const image = file.images[j];
          if (
            (!image.printSettings || !image.printSettings.paperType) &&
            !image.resizeProcessing
          ) {
            this.onChooseImage(file, image, j);
            this.isAllFilesHavePaper = false;
            this.cdr.detectChanges();
            this.isScrollNeeded = true;
            return;
          }
        }
      }
      if (isFromResize) {
        this.proccessingFiles = [];
        let isFileFound = false;
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i];
          if (
            !file.images ||
            file.images.length === 0 ||
            this.isFileResizing(file)
          ) {
            this.proccessingFiles.push(file);
          } else {
            for (let j = 0; j < file.images.length; j++) {
              const image = file.images[j];
              if (!image.resizeProcessing && !isFileFound) {
                this.onChooseImage(file, image, j);
                this.isAllFilesHavePaper = false;
                this.cdr.detectChanges();
                this.isScrollNeeded = true;
                isFileFound = true;
              }
            }
          }
        }
        if (this.proccessingFiles?.length !== this.files?.length) {
          this.checkIsAllFilesHavePaper();
        } else {
          this.clearPreviewData();
          this.clearPreviewDataDeep();
        }
      }
    } else if (this.printingService === 'express') {
      // [express]
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        if (
          (!file.printSettings || !file.printSettings?.paperType) &&
          file.images?.length > 0
        ) {
          this.isAllFilesHavePaper = false;
          this.onChooseImage(file, file.images[0], 0);
          this.isScrollNeeded = true;
          return;
        }
      }
    }
  }

  // scrollToNextImage() {
  //   console.log('scrollToNextImage file-obj-{{i}}-image-{{j}} in plotter');
  //   setTimeout(() => {
  //     let elements: QueryList<ElementRef>;
  //     if (this.printingService === 'plotter') {
  //       elements = this.fileElements;
  //     } else if (this.printingService === 'express') {
  //       elements = this.fileExpressElements;
  //     }
  //     if (elements && elements.length > 0) {
  //       const targetFileIndex = this.files.findIndex(file => file._id === this.currentFile._id);
  //       if (targetFileIndex !== -1) {
  //         this.currentFileIndex = targetFileIndex;
  //       }
  //       elements.toArray()[this.currentFileIndex].nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       const images = this.files[this.currentFileIndex].images;
  //     }

  //     // Scroll the page to the top after a delay
  //     setTimeout(() => {
  //       window.scrollTo({ top: 0, behavior: 'smooth' });
  //     }, 100); // adjust the delay as needed
  //   }, 0);
  // }
  scrollToNextImage() {
    // console.log('scrollToNextImage file-obj-{{i}}-image-{{j}} in plotter');
    setTimeout(() => {
      if (this.printingService === 'plotter') {
        // גלילה לפי id של התמונה הנוכחית
        const fileIndex = this.files.findIndex(
          (file) => file._id === this.currentFile._id
        );
        const imageIndex = this.currentFile.images.findIndex(
          (img) => img._id === this.currentImage._id
        );
        // console.log("fileIndex", fileIndex, "imageIndex", imageIndex);
        if (fileIndex !== -1 && imageIndex !== -1) {
          const elementId = `file-obj-${fileIndex}-image-${imageIndex}`;
          const el = document.getElementById(elementId);
          // console.log("elementId", elementId, "el", el);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      } else if (this.printingService === 'express') {
        // התנהגות קיימת לאקספרס
        let elements = this.fileExpressElements;
        if (elements && elements.length > 0) {
          elements
            .toArray()
            [this.currentFileIndex].nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
        }
      }

      // Scroll the page to the top after a delay
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 1000);
    }, 0);
  }

  // [plotter + express]
  checkIsAllFilesHavePaper() {
    let FinishedFiles = this.files.filter(
      (file) => file.images.length > 0 && !this.isFileResizing(file)
    );
    if (this.printingService === 'plotter') {
      this.isAllFilesHavePaper = FinishedFiles.every((file) =>
        file.images.every((image) => image.printSettings?.paperType ?? false)
      );
    } else if (this.printingService === 'express') {
      this.isAllFilesHavePaper = FinishedFiles.every(
        (file) => file.printSettings?.paperType ?? false
      );
    }
    if (this.printingService === 'plotter') {
      this.files.forEach((file) => {
        file.images.forEach((image, imageIndex) => {
          if (image.resizeError) {
            image.resizeError = false;
            // console.log('image.resizeError', file._id, imageIndex, image.resizeError);
            this.filesService
              .updateResizeError(file._id, imageIndex)
              .subscribe((response) => {
                // console.log('Image updated:', response);
                setTimeout(() => {
                  throw new Error('ERROR_RESIZING_IMAGE');
                });
              });
          }
        });
      });
    }

    setTimeout(() => {
      if (
        !this.isOpeningCompMainBtn &&
        ((this.isAllFilesHavePaper && !this.lastIsAllFilesHavePaper) ||
          (!this.isAllFilesHavePaper &&
            this.lastIsAllFilesHavePaper &&
            !this.currentPaperType))
      ) {
        if (this.isAllFilesHavePaper) {
          this.lastIsAllFilesHavePaper = true;
        } else {
          this.lastIsAllFilesHavePaper = false;
        }
        this.stopAnimateMainBtn();
        setTimeout(() => {
          this.animateMainBtn();
        }, 0);
      }

      if (this.isOpeningCompMainBtn && this.currentPaperType) {
        this.isOpeningCompMainBtn = false;
        setTimeout(() => {
          this.animateMainBtn();
        }, 0);
      }
    }, 0);
  }

  // more properties -------------------------------------------------

  // [express + plotter] - printSettings

  get currentPrintSettings() {
    if (this.printingService === 'plotter') {
      return this.currentImage?.printSettings
        ? this.currentImage.printSettings
        : {};
    } else if (this.printingService === 'express') {
      return this.currentFile?.printSettings
        ? this.currentFile.printSettings
        : {};
    }
  }

  set currentPrintSettings(value) {
    if (this.printingService === 'plotter') {
      this.currentImage.printSettings = value;
    } else if (this.printingService === 'express') {
      this.currentFile.printSettings = value;
    }
  }

  // [express] - doubleSidedValue
  get doubleSidedValue() {
    return this.currentPrintSettings?.doubleSided;
  }

  set doubleSidedValue(value) {
    this.currentPrintSettings.doubleSided = value;
  }

  // [express + plotter] - paperType
  get currentPaperType() {
    return this.currentPrintSettings?.paperType;
  }

  set currentPaperType(value) {
    if (this.isOriginalImgFitPaper(value)) {
      this.currentPrintSettings.paperType = value;
    }
  }

  // [express] - fitValue
  get fitValue() {
    return this.currentPrintSettings?.fit;
  }

  set fitValue(value) {
    this.currentPrintSettings.fit = value;
  }

  // [express] - cropRatioValue ("fully cover")
  get cropRatioValue() {
    return this.currentPrintSettings?.cropRatio;
  }

  set cropRatioValue(value) {
    this.currentPrintSettings.cropRatio = value;
  }

  // [plotter + express] - bwValue
  get bwValue() {
    return this.currentPrintSettings?.bw;
  }

  set bwValue(value) {
    this.currentPrintSettings.bw = value;
  }

  // [plotter + express] - numOfCopies
  get numOfCopies() {
    return this.currentPrintSettings?.numOfCopies;
  }

  set numOfCopies(value) {
    this.currentPrintSettings.numOfCopies = value;
  }

  changeNumberOfCopies(type: string) {
    const originalNumOfCopies = this.numOfCopies;
    if (type === 'add') {
      this.numOfCopies++;
    } else if (type === 'remove' && this.numOfCopies > 1) {
      this.numOfCopies--;
    }
    if (originalNumOfCopies !== this.numOfCopies) {
      this.onFileSettingsChangeBySystem();
    }
  }

  // [plotter] - centerValue
  get centerValue() {
    return this.currentPrintSettings?.centered;
  }

  set centerValue(value) {
    this.currentPrintSettings.centered = value;
  }

  // [plotter] - cmFromTopValue
  get cmFromTopValue() {
    return this.currentPrintSettings?.cmFromTop;
  }

  set cmFromTopValue(value) {
    this.currentPrintSettings.cmFromTop = value;
  }

  // [plotter + express]
  sendToPrint(): void {
    // console.log('sendToPrint > open dialog to to aprove these files: ', this.files);
    this.openOrderSummaryDialog();
  }

  // [plotter + express]
  openOrderSummaryDialog() {
    // console.log('BRANCH: ', this.realBranch);
    this.stopAnimateMainBtn();

    if (this.printingService === 'plotter') {
      // Order Summary - [plotter]
      if (this.files && this.files.length > 0) {
        // get files and remove proccessing files
        const orderFilesBeforeClean = [...this.files];
        let orderFiles = [];

        let isAllValid = true;
        orderFilesBeforeClean.forEach((file) => {
          if (file.images.length > 0 && !this.isFileResizing(file)) {
            for (let i = 0; i < file.images.length; i++) {
              if (!file.images[i].price || file.images[i].price === 0) {
                this.onChooseImage(file, file.images[i], i);
                this.onFileSettingsChange();
                isAllValid = false;
              }
            }
            orderFiles.push(file);
          }
        });

        if (!isAllValid) {
          return;
        }

        let orderFilesData = [];

        for (let i = 0; i < orderFiles.length; i++) {
          const file = orderFiles[i];
          if (file.images.length > 0) {
            const fileData = {
              name: file.fileName,
              originalFileName: file.originalFileName,
              fileId: file._id,
              images: [],
            };
            for (let j = 0; j < file.images.length; j++) {
              const image = file.images[j];
              const paperSerialName = this.printServicePapers.find(
                (paper) =>
                  paper.paperType.paperPrinterCode ===
                  image.printSettings.paperType
              ).paperType.paperType;
              const resizeFactor = this.roundDownTowDecimal(
                (image.imageHeight / image.origImageHeight) * 100
              );
              const iamgeData = {
                settings: image.printSettings,
                paperSerialName: paperSerialName,
                width: image.imageWidth,
                height: image.imageHeight,
                resizeFactor: resizeFactor,
                price: image.price,
                path:
                  this.serverAddress +
                  '/uploads/' +
                  this.getUserNameForFile(file) +
                  '/' +
                  image.thumbnailPath.split('/').pop(),
              };
              fileData.images.push(iamgeData);
            }
            orderFilesData.push(fileData);
          }
        }
        // open dialog
        const present = this.user.discount ? 100 - this.user.discount : 100;
        // console.log('totalOrderPriceBeforeDiscount: ', this.totalOrderPrice, this.totalOrderPrice * (present / 100));
        const totalOrderPriceAfterDiscount =
          this.totalOrderPrice * (present / 100);
        syncIsNotAcademyFromCluster(this.realBranch, 'plotter');
        this.dialogService.onOpenOrderSummaryDialog(
          this.printingService,
          this.serverAddress,
          this.printServicePapers,
          orderFilesData,
          this.branch,
          {
            totalOrderPriceBeforeDiscount: this.totalOrderPriceBeforeDiscount,
            totalOrderPrice: totalOrderPriceAfterDiscount,
            points: this.user.points ? this.user.points : 0,
          },
          this.user,
          false,
          this.isManiger(),
          this.realBranch.plotter.unique,
          this.branchID,
          this.realBranch.plotter.printers[0]._id
        );
      }
    } else if (this.printingService === 'express') {
      // Order Summary - [express]
      if (this.files && this.files.length > 0) {
        if (!this.isPicsPrinter()) {
          this.fixFitForAllFilesIfNeeded();
        } else {
          this.removeFitFromAllFilesForPicsPrinter();
        }

        // get files and remove proccessing files
        const orderFilesBeforeClean = [...this.files];
        let orderFiles = [];

        let isAllValid = true;
        orderFilesBeforeClean.forEach((file) => {
          if (file.images.length > 0) {
            if (!file.price || file.price === 0) {
              this.onChooseImage(file, 0, 0);
              this.onFileSettingsChangeExpress();
              isAllValid = false;
            }
            orderFiles.push(file);
          }
        });

        if (!isAllValid) {
          return;
        }

        let orderFilesData = [];
        // console.log('orderFiles $$$: ', orderFiles);
        // file
        for (let i = 0; i < orderFiles.length; i++) {
          const file = orderFiles[i];
          // remove proccessing files
          if (file.images.length === 0) {
            return;
          }

          if (this.realBranch.express.properties.enable_crop) {
            if (!file.printSettings.cropRatio) {
              file.printSettings.fit = true;
            }
          } else {
            file.printSettings.cropRatio = false;
          }

          const paperSerialName = this.printServicePapers.find(
            (paper) => paper.paperName === file.printSettings.paperType
          ).serial_name;
          const fileData = {
            _id: file._id,
            name: file.fileName,
            originalFileName: file.originalFileName,
            fileId: file._id,
            settings: file.printSettings,
            paperSerialName: paperSerialName,
            images: [],
            price: {
              pricePerPage: this.getImagePrice(
                file.printSettings,
                this.realBranch.express.pricing.prices_x
              ),
              pages: file.images.length,
              copies: file.printSettings.numOfCopies,
            },
          };

          // Get paper width
          let paperType = this.printServicePapers.find(
            (paper) => paper.paperName === file.printSettings.paperType
          ).paperType;

          let paperWidth = 0;
          let paperHeight = 0;
          if (paperType === 'A4') {
            paperWidth = 21;
            paperHeight = 29.7;
          } else if (paperType === 'A3') {
            paperWidth = 29.7;
            paperHeight = 42;
          } else if (paperType === 'CY-SM') {
            paperWidth = 10.16;
            paperHeight = 15.24;
          } else if (paperType === 'CY-MD') {
            paperWidth = 12.7;
            paperHeight = 17.78;
          } else if (paperType === 'CY-LG') {
            paperWidth = 15.24;
            paperHeight = 20.32;
          }

          // image
          for (let j = 0; j < file.images.length; j++) {
            // if DO fit
            let scaleImageFactor = 1;
            let imageHeight;
            let imageWidth;

            // Calculate if needs to rotate 1
            let BeforeRotationImageWidth =
              (file.images[j].imageWidth / file.images[j].origImageDPI) * 2.54;
            let BeforeRotationImageHeight =
              (file.images[j].imageHeight / file.images[j].origImageDPI) * 2.54;

            if (file.printSettings.fit) {
              // Calculate biddest dims of all images
              let BeforeRotationAllImagesBiggestWidth = file.images.reduce(
                (max, image) => {
                  return Math.max(
                    max,
                    (image.imageWidth / image.origImageDPI) * 2.54
                  );
                },
                0
              );
              let BeforeRotationAllImagesBiggestHeight = file.images.reduce(
                (max, image) => {
                  return Math.max(
                    max,
                    (image.imageHeight / image.origImageDPI) * 2.54
                  );
                },
                0
              );

              const biggerPaperDimm = Math.max(paperWidth, paperHeight);
              const smallerPaperDimm = Math.min(paperWidth, paperHeight);

              let isFitRequired = false;

              // check if original size is possible
              if (
                (biggerPaperDimm > BeforeRotationAllImagesBiggestWidth &&
                  smallerPaperDimm > BeforeRotationAllImagesBiggestHeight) ||
                (biggerPaperDimm > BeforeRotationAllImagesBiggestHeight &&
                  smallerPaperDimm > BeforeRotationAllImagesBiggestWidth)
              ) {
                // original size is possible
                // console.log('original size is possible !!');
                isFitRequired = false;
              } else {
                // original size is NOT possible
                // console.log('original size is NOT possible !!');
                file.printSettings.fit = true;
                isFitRequired = true;
              }

              // fit in original size and orientation?
              if (file.printSettings.fit) {
                // do fit
                // console.log('do fit !!');
                let factorIfNotRotater;
                let factorIfRotater;
                // check if original size is possible
                if (
                  BeforeRotationImageWidth / paperWidth >
                  BeforeRotationImageHeight / paperHeight
                ) {
                  factorIfNotRotater = BeforeRotationImageWidth / paperWidth;
                  // console.log("factorIfNotRotater 01", factorIfNotRotater);
                } else {
                  factorIfNotRotater = BeforeRotationImageHeight / paperHeight;
                  // console.log("factorIfNotRotater 02", factorIfNotRotater);
                }
                if (
                  BeforeRotationImageWidth / paperHeight >
                  BeforeRotationImageHeight / paperWidth
                ) {
                  factorIfRotater = BeforeRotationImageWidth / paperHeight;
                  // console.log("factorIfRotater 03", factorIfRotater);
                } else {
                  factorIfRotater = BeforeRotationImageHeight / paperWidth;
                  // console.log("factorIfRotater 04", factorIfRotater);
                }

                if (factorIfRotater < factorIfNotRotater) {
                  // do rotate
                  // console.log('do rotate !!');
                  // --- this.isCurrentrotated = true;
                  const AfretRotationImageWidth = BeforeRotationImageHeight;
                  const AfretRotationImageHeight = BeforeRotationImageWidth;
                  if (
                    paperWidth / AfretRotationImageWidth <
                    paperHeight / AfretRotationImageHeight
                  ) {
                    // fit to width
                    // console.log('fit to width !!');
                    scaleImageFactor = paperWidth / AfretRotationImageWidth;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  } else {
                    // fit to height
                    // console.log('fit to height !!');
                    scaleImageFactor = paperHeight / AfretRotationImageHeight;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  }
                } else {
                  // dont rotate
                  // console.log('dont rotate !!');
                  // --- this.isCurrentrotated = false;
                  const AfretRotationImageWidth = BeforeRotationImageWidth;
                  const AfretRotationImageHeight = BeforeRotationImageHeight;
                  if (
                    paperWidth / AfretRotationImageWidth <
                    paperHeight / AfretRotationImageHeight
                  ) {
                    // fit to width
                    // console.log('fit to width !!');
                    scaleImageFactor = paperWidth / AfretRotationImageWidth;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  } else {
                    // fit to height
                    // console.log('fit to height !!');
                    scaleImageFactor = paperHeight / AfretRotationImageHeight;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  }
                }
              }
            } else {
              // dont fit
              // console.log('dont fit !!');
              if (
                paperWidth > BeforeRotationImageWidth &&
                paperHeight > BeforeRotationImageHeight
              ) {
                // do fit in original size and orientation
                // console.log('do fit in original size and orientation');
                // this.isCurrentrotated = false;
                imageHeight = BeforeRotationImageHeight;
                imageWidth = BeforeRotationImageWidth;
              } else {
                // doesnt fit in original size and orientation
                // console.log('doesnt fit in original size and orientation');
                // this.isCurrentrotated = true;
                imageHeight = BeforeRotationImageWidth;
                imageWidth = BeforeRotationImageHeight;
              }
            }

            const image = file.images[j];
            const imageData = {
              index: j,
              width: this.roundDownTowDecimal(imageWidth),
              height: this.roundDownTowDecimal(imageHeight),
              scaleFactor: this.roundDownTowDecimal(scaleImageFactor * 100),
              path:
                this.expressServerAdress +
                '/uploads/' +
                this.getUserNameForFile(file) +
                '/' +
                image.thumbnailPath.split('/').pop(),
            };
            // console.log('imageData ::::: ', imageData);
            fileData.images.push(imageData);
          }
          // console.log('fileData ::::: ', fileData);
          orderFilesData.push(fileData);
        }
        let code = 0;
        if (
          this.realBranch.express?.unique &&
          this.realBranch.express?.properties?.code
        ) {
          code = this.printingCode(
            this.realBranch.express.unique,
            this.realBranch.express.properties.code
          );
        }
        // open dialog
        const present = this.user.discount ? 100 - this.user.discount : 100;
        const totalOrderPriceAfterDiscount =
          this.totalOrderPrice * (present / 100);
        // fix products
        let fixProducts = null;
        let fixProductsData = {};
        if (this.branchHasFixProducts() && this.totalOrderdFixProducts() > 0) {
          fixProducts = this.realBranch.express.fix_products;
          for (let i = 0; i < fixProducts.length; i++) {
            if (fixProducts[i].price && fixProducts[i].price > 0) {
              fixProducts[i].productId.defaultPrice = fixProducts[i].price;
            }
          }
          fixProductsData = {
            products: fixProducts,
            totalAmount: this.totalOrderdFixProducts(),
            totalCost: this.totalOrderdFixProductsPrice(),
          };
        }
        syncIsNotAcademyFromCluster(this.realBranch, 'express');
        this.dialogService.onOpenOrderSummaryDialog(
          this.printingService,
          this.serverAddress,
          this.printServicePapers,
          orderFilesData,
          this.branch,
          {
            totalOrderPriceBeforeDiscount: this.totalOrderPriceBeforeDiscount,
            totalOrderPrice: totalOrderPriceAfterDiscount,
            points: this.user.points ? this.user.points : 0,
            fixProductsTotalPrice: this.fixProductsTotalPrice,
          },
          this.user,
          false,
          this.isManiger(),
          this.realBranch.express.unique,
          this.branchID,
          this.realBranch.express._id,
          null,
          code,
          fixProducts ? fixProductsData : null,
          this.isPicsPrinter(),
          this.isPicsDiscountUsed ? this.getSmallImagePriceDiscounted() : null,
          null,
          this.realBranch?.express?.properties?.skipCode || false,
          null,
          null,
          null,
          this.forceRasterize
        );
      } else if (
        this.branchHasFixProducts() &&
        this.fixProductsTotalPrice > 0
      ) {
        // fix products
        let code = 0;
        if (
          this.realBranch.express?.unique &&
          this.realBranch.express?.properties?.code
        ) {
          code = this.printingCode(
            this.realBranch.express.unique,
            this.realBranch.express.properties.code
          );
        }
        let fixProducts = null;
        let fixProductsData = {};
        if (this.branchHasFixProducts() && this.totalOrderdFixProducts() > 0) {
          fixProducts = this.realBranch.express.fix_products;
          for (let i = 0; i < fixProducts.length; i++) {
            if (fixProducts[i].price && fixProducts[i].price > 0) {
              fixProducts[i].productId.defaultPrice = fixProducts[i].price;
            }
          }
          fixProductsData = {
            products: fixProducts,
            totalAmount: this.totalOrderdFixProducts(),
            totalCost: this.totalOrderdFixProductsPrice(),
          };
        }
        syncIsNotAcademyFromCluster(this.realBranch, 'express');
        this.dialogService.onOpenOrderSummaryDialog(
          this.printingService,
          this.serverAddress,
          this.printServicePapers,
          null,
          this.branch,
          {
            totalOrderPriceBeforeDiscount: 0,
            totalOrderPrice: 0,
            points: 0,
            fixProductsTotalPrice: this.fixProductsTotalPrice,
          },
          this.user,
          false,
          this.isManiger(),
          this.realBranch.express.unique,
          this.branchID,
          this.realBranch.express._id,
          null,
          code,
          fixProducts ? fixProductsData : null,
          this.isPicsPrinter(),
          null,
          null,
          this.realBranch?.express?.properties?.skipCode || false
        );
      }
    }
  }

  fixFitForAllFilesIfNeeded() {
    for (const file of this.files) {
      // ודא שיש הגדרות הדפסה ותמונות
      if (!file.printSettings || !file.images || file.images.length === 0)
        continue;

      // ודא שיש paperType חוקי
      const paper = this.printServicePapers.find(
        (p) => p.paperName === file.printSettings.paperType
      );
      if (!paper) continue;

      // קבע מידות נייר
      let paperWidth = 0;
      let paperHeight = 0;
      const paperType = paper.paperType;
      if (paperType === 'A4') {
        paperWidth = 21;
        paperHeight = 29.7;
      } else if (paperType === 'A3') {
        paperWidth = 29.7;
        paperHeight = 42;
      } else if (paperType === 'CY-SM') {
        paperWidth = 10.16;
        paperHeight = 15.24;
      } else if (paperType === 'CY-MD') {
        paperWidth = 12.7;
        paperHeight = 17.78;
      } else if (paperType === 'CY-LG') {
        paperWidth = 15.24;
        paperHeight = 20.32;
      } else {
        continue; // לא נמצא סוג נייר מתאים
      }

      // חישוב המידות הגדולות ביותר של כל התמונות
      let BeforeRotationAllImagesBiggestWidth = file.images.reduce(
        (max, image) => {
          return Math.max(max, (image.imageWidth / image.origImageDPI) * 2.54);
        },
        0
      );
      let BeforeRotationAllImagesBiggestHeight = file.images.reduce(
        (max, image) => {
          return Math.max(max, (image.imageHeight / image.origImageDPI) * 2.54);
        },
        0
      );

      const printableArea = this.getExpressPrintableArea(paperWidth, paperHeight);
      const biggerPaperDimm = Math.max(printableArea.width, printableArea.height);
      const smallerPaperDimm = Math.min(printableArea.width, printableArea.height);

      // בדוק אם צריך fit
      const isFitRequired = !(
        (biggerPaperDimm > BeforeRotationAllImagesBiggestWidth &&
          smallerPaperDimm > BeforeRotationAllImagesBiggestHeight) ||
        (biggerPaperDimm > BeforeRotationAllImagesBiggestHeight &&
          smallerPaperDimm > BeforeRotationAllImagesBiggestWidth)
      );

      if (isFitRequired) {
        file.printSettings.fit = true;
      }
    }
  }

  removeFitFromAllFilesForPicsPrinter() {
    for (const file of this.files) {
      if (file.printSettings) {
        file.printSettings.fit = false;
      }
    }
  }

  private printingCode(printerNum: number, randomDigits: number) {
    let code = '00000';
    if (printerNum && randomDigits) {
      code =
        printerNum.toString().charAt(0) +
        randomDigits.toString().charAt(0) +
        printerNum.toString().charAt(1) +
        randomDigits.toString().charAt(1) +
        printerNum.toString().charAt(2);
    }
    return parseInt(code);
  }

  // [plotter]
  openResizeDialog(
    isMustResize: boolean,
    paperWidth: number = null,
    paperType: string = null
  ) {
    const paperTypeReal = paperType
      ? paperType
      : this.selectedPaper?.paperType?.paperType;
    const paperId = this.printServicePapers.find(
      (paper) => paper.paperType.paperType === paperTypeReal
    )?.paperType?._id;
    // console.log('paperId:', paperId);
    if (!paperTypeReal || !paperId) {
      return;
    }
    const imagePath =
      'https://' +
      this.branch +
      '.eazix.io/uploads/' +
      this.getUserName() +
      '/' +
      this.currentImage.thumbnailPath.split('\\').pop();
    this.dialogService.onOpenResizeDialog(
      paperWidth ? paperWidth : this.currentPaperWidth,
      this.currentFile,
      this.currentImageIndex,
      paperTypeReal,
      this.currentImage,
      imagePath,
      isMustResize,
      this.serverAddress,
      paperId
    );
  }

  // [express]
  getPaperSerialName(file) {
    const paper = this.printServicePapers.find(
      (paper) => paper.paperName === file.printSettings.paperType
    );
    if (!paper) {
      this.clearPreviewData();
      this.clearPreviewDataDeep();
      return '';
    }
    return paper ? paper.serial_name : '';
  }

  // [plotter]
  checkReturnedResizedFile() {
    if (this.currentImage) {
      this.currentImage.resizeProcessing = true;
      this.nextImageToSetPaper(true);
    }
  }

  get prices$() {
    if (!this.realBranch) {
      return of([]);
    }

    const prices = this.realBranch.express.pricing.prices_x;
    return of(prices);
  }

  getImagePrice$(imagePrintSettings: any): Observable<number> {
    return this.prices$.pipe(
      map((prices) => {
        const imagePrice = this.getImagePrice(imagePrintSettings, prices);
        return imagePrice;
      })
    );
  }

  imagePrice$ = combineLatest([this.imagePrintSettings$, this.prices$]).pipe(
    map(([imagePrintSettings, prices]) =>
      this.getImagePrice(imagePrintSettings, prices)
    )
  );

  getImagePrice(imagePrintSettings: any, prices: any): number {
    if (!imagePrintSettings || !imagePrintSettings?.paperType || !prices) {
      this.totalOrderPrice = 0;
      this.totalOrderPriceBeforeDiscount = 0;
      this.totalOrderPriceToBeforeUpdate = 0;
      this.totalOrderPriceBeforeDiscountToBeforeUpdate = 0;
      return 0;
    }
    const imagePaperType = imagePrintSettings.paperType
      .replace("'", "\\'")
      .replace('\\', '')
      .toLowerCase();
    const imagePrices = prices;
    const lowerCaseImagePrices = Object.keys(imagePrices).reduce(
      (result, key) => {
        result[key.toLowerCase()] = imagePrices[key];
        return result;
      },
      {}
    );
    const imagePaperPrices = lowerCaseImagePrices[imagePaperType];
    if (imagePaperPrices && imagePaperPrices.single) {
      if (!imagePrintSettings.doubleSided) {
        if (!imagePrintSettings.bw) {
          return this.roundDownTowDecimal(imagePaperPrices.single.color);
        } else {
          return this.roundDownTowDecimal(imagePaperPrices.single.bw);
        }
      } else {
        if (!imagePrintSettings.bw) {
          return this.roundDownTowDecimal(imagePaperPrices.double.color);
        } else {
          return this.roundDownTowDecimal(imagePaperPrices.double.bw);
        }
      }
    } else {
      return 0;
    }
  }

  calcTotalOrderPrice() {
    // [plotter]
    if (this.printingService === 'plotter') {
      let totalPrice = 0;
      if (this.files.length > 0) {
        for (let file of this.files) {
          if (file.images.length > 0) {
            for (let image of file.images) {
              if (
                image.printSettings &&
                image.printSettings.paperType &&
                !image.resizeProcessing
              ) {
                const copies = image.printSettings.numOfCopies
                  ? image.printSettings.numOfCopies
                  : 1;
                totalPrice = totalPrice + image.price * copies;
              }
            }
          }
        }
      }
      this.totalOrderPrice = totalPrice;
      this.totalOrderPriceBeforeDiscount = totalPrice;
      this.totalOrderPriceToBeforeUpdate = totalPrice;
      this.totalOrderPriceBeforeDiscountToBeforeUpdate = totalPrice;
      // [express]
    } else if (this.printingService === 'express') {
      this.totalOrderPrice = 0;
      this.totalOrderPriceBeforeDiscount = 0;
      this.totalOrderPriceToBeforeUpdate = 0;
      this.totalOrderPriceBeforeDiscountToBeforeUpdate = 0;
      for (let file of this.files) {
        if (file.printSettings && file.printSettings.paperType) {
          const filePrintSettings = file.printSettings;
          const imagePaperType = filePrintSettings.paperType
            .replace("'", "\\'")
            .replace('\\', '')
            .toLowerCase();
          const imagePrices = this.realBranch.express.pricing.prices_x;
          const imagePricesX = this.realBranch.express.pricing.prices;
          const imageX = this.realBranch.express.pricing.x;
          const lowerCaseImagePrices = Object.keys(imagePrices).reduce(
            (result, key) => {
              result[key.toLowerCase()] = imagePrices[key];
              return result;
            },
            {}
          );
          const lowerCaseImagePricesX = Object.keys(imagePricesX).reduce(
            (result, key) => {
              result[key.toLowerCase()] = imagePricesX[key];
              return result;
            },
            {}
          );
          const imagePaperPrices = lowerCaseImagePrices[imagePaperType];
          const imagePaperPricesX = lowerCaseImagePricesX[imagePaperType];
          if (imagePaperPrices && imagePaperPrices.single) {
            if (!filePrintSettings.doubleSided) {
              // single sided
              // console.log('single sided');
              if (!filePrintSettings.bw) {
                // color
                // console.log('color');
                this.sortedFilesArray.push({
                  type: imagePaperType + '-single-color',
                  price: this.roundDownTowDecimal(
                    imagePaperPrices.single.color
                  ),
                  priceX: this.roundDownTowDecimal(
                    imagePaperPricesX.single.color
                  ),
                  x: imageX,
                  copies: filePrintSettings.numOfCopies * file.images.length,
                });
              } else {
                // black and white
                // console.log('black and white');
                this.sortedFilesArray.push({
                  type: imagePaperType + '-single-bw',
                  price: this.roundDownTowDecimal(imagePaperPrices.single.bw),
                  priceX: this.roundDownTowDecimal(imagePaperPricesX.single.bw),
                  x: imageX,
                  copies: filePrintSettings.numOfCopies * file.images.length,
                });
              }
            } else {
              // double sided
              // console.log('double sided');
              if (!filePrintSettings.bw) {
                // color
                // console.log('color');
                this.sortedFilesArray.push({
                  type: imagePaperType + '-double-color',
                  price: this.roundDownTowDecimal(
                    imagePaperPrices.double.color
                  ),
                  priceX: this.roundDownTowDecimal(
                    imagePaperPricesX.double.color
                  ),
                  x: imageX,
                  copies: filePrintSettings.numOfCopies * file.images.length,
                });
              } else {
                // black and white
                // console.log('black and white');
                this.sortedFilesArray.push({
                  type: imagePaperType + '-double-bw',
                  price: this.roundDownTowDecimal(imagePaperPrices.double.bw),
                  priceX: this.roundDownTowDecimal(imagePaperPricesX.double.bw),
                  x: imageX,
                  copies: filePrintSettings.numOfCopies * file.images.length,
                });
              }
            }
          }
        }
      }

      // normal price (before discount)
      let sortedFilesByTypeArray = [];
      this.sortedFilesArray.forEach((sortedFile) => {
        if (
          sortedFilesByTypeArray.some(
            (sortedFileByType) => sortedFileByType.type === sortedFile.type
          )
        ) {
          // existing sort
          sortedFilesByTypeArray.forEach((sortedFileByType, index) => {
            if (sortedFileByType.type === sortedFile.type) {
              sortedFilesByTypeArray[index].copies += sortedFile.copies;
            }
          });
        } else {
          // new sort
          sortedFilesByTypeArray.push(sortedFile);
        }
      });

      let totalNonDiscountPrice = 0;
      sortedFilesByTypeArray.forEach((sortedFileByType) => {
        totalNonDiscountPrice +=
          sortedFileByType.copies * sortedFileByType.price;
      });

      // console.log('totalNonDiscountPrice =========:', totalNonDiscountPrice);

      let totalDiscountPrice = 0;
      sortedFilesByTypeArray.forEach((sortedFileByType) => {
        if (sortedFileByType.copies <= sortedFileByType.x) {
          // less then x
          totalDiscountPrice +=
            sortedFileByType.copies * sortedFileByType.price;
        } else {
          // more then x
          totalDiscountPrice += sortedFileByType.x * sortedFileByType.price;
          totalDiscountPrice +=
            (sortedFileByType.copies - sortedFileByType.x) *
            sortedFileByType.priceX;
        }
      });

      if (this.branchHasFixProducts()) {
        this.fixProductsTotalPriceToBeforeUpdate =
          this.totalOrderdFixProductsPrice()
            ? this.totalOrderdFixProductsPrice()
            : 0;
      } else {
        this.fixProductsTotalPriceToBeforeUpdate = 0;
      }
      this.totalOrderPriceToBeforeUpdate =
        this.roundDownOneDecimal(totalDiscountPrice) / 100 -
        (this.isPicsDiscountOn() ? this.getSmallImagePriceDiscounted() : 0);
      this.totalOrderPriceBeforeDiscountToBeforeUpdate =
        this.roundDownOneDecimal(totalNonDiscountPrice) / 100;
      this.sortedFilesArray = [];
    }
  }

  clearPriceData() {
    this.totalOrderPrice = 0;
    this.totalOrderPriceBeforeDiscount = 0;
    this.totalOrderPriceToBeforeUpdate = 0;
    this.totalOrderPriceBeforeDiscountToBeforeUpdate = 0;
    // console.log('clearPriceData');
  }

  isMaxInkLevelDisableingFile(paper: any, file: any) {
    if (this.printingService === 'express') {
      let maxInkLevelOfAllImages = 0;
      if (
        this.files &&
        this.proccessingFiles &&
        this.files.length > 0 &&
        this.files.length !== this.proccessingFiles.length
      ) {
        if (!file.images || file.images?.length === 0) {
          return false;
        }
        for (let image of file.images) {
          if (image.inkLevel > maxInkLevelOfAllImages) {
            maxInkLevelOfAllImages = image.inkLevel;
          }
        }
      }
      let paperMaxInkLevel = 100;
      if (paper?.maxInkLevel) {
        paperMaxInkLevel = paper.maxInkLevel;
      }
      return maxInkLevelOfAllImages > paperMaxInkLevel;
    } else {
      return false;
    }
  }

  isMaxInkLevelDisableingSomeOfTheImages(paper: any, file: any) {
    if (this.printingService === 'express') {
      let paperMaxInkLevel = 0;
      if (paper?.maxInkLevel) {
        paperMaxInkLevel = paper.maxInkLevel;
      } else {
        return false;
      }
      let aboveAmount = 0;
      let underAmount = 0;
      let aboveIndexesArray = [];
      let underIndexesArray = [];
      if (!file.images || file.images?.length === 0) {
        return false;
      }
      for (let [index, image] of file.images.entries()) {
        if (image.inkLevel >= paperMaxInkLevel) {
          aboveAmount += 1;
          aboveIndexesArray.push(index);
        } else {
          underAmount += 1;
          underIndexesArray.push(index);
        }
      }
      return [aboveAmount, underAmount, aboveIndexesArray, underIndexesArray];
    } else {
      return false;
    }
  }

  maxInkLevelDisableSnackBar(isApplyToAll: boolean = false, paper: any = null) {
    let message = 'printing-table.max-ink-level';
    if (paper.isPreventedForUse) {
      message = 'printing-table.prevented-for-use';
    }
    if (!this.currentFile || !this.files || this.files.length === 0) {
      return;
    }
    if (isApplyToAll && !paper.isPreventedForUse) {
      message = 'printing-table.max-ink-level.apply-to-all';
    }
    this.snackBar.open(this.translateService.instant(message), '', {
      duration: 5000,
      verticalPosition: 'top',
      panelClass: 'zx-top-snackbar',
    });
    this.isLoadingPreview = false;
  }

  // normal tooltips
  toggleTooltip(value: string) {
    if (value === 'ScanCopy') {
      if (this.tooltipScanCopy._isTooltipVisible()) {
        this.tooltipScanCopy.hide();
      } else {
        this.tooltipScanCopy.show();
      }
    }
    if (value === 'FixProducts') {
      if (this.tooltipFixProducts._isTooltipVisible()) {
        this.tooltipFixProducts.hide();
      } else {
        this.tooltipFixProducts.show();
      }
    }
  }

  // [express]
  // scan and copy
  openScanCopyDialog(event: MouseEvent) {
    // Check if the click event was inside the tooltip element
    const isClickInsideTooltip = (event.target as Element).classList.contains(
      'i-explain-icon'
    );

    // Check if the device is a mobile device
    const isMobileDevice = window.innerWidth <= 768;

    // Only open the dialog if the device is not a mobile device, or if the click was not inside the tooltip element

    if (!isMobileDevice || !isClickInsideTooltip) {
      this.dialogService.onOpenScanCopyDialog(this.realBranch.express);
    }
  }

  openInkGradientDialog() {
    if (!this.isSu() || this.printingService !== 'express' || !this.currentFile) {
      return;
    }
    this.dialogService.onOpenInkGradientDialog(
      this.currentFile,
      this.serverAddress,
      this.getUserNameForFile(this.currentFile)
    );
  }

  // explain property dialog
  openExplainPropertyDialog(property: string) {
    let isPaperChoosen = false;
    if (this.printingService === 'plotter') {
      isPaperChoosen = this.currentImage?.printSettings?.paperType
        ? true
        : false;
    } else if (this.printingService === 'express') {
      isPaperChoosen = this.currentFile?.printSettings?.paperType
        ? true
        : false;
    }
    this.dialogService.onOpenExplainPropertyDialog(
      property,
      this.printingService,
      this.realBranch,
      isPaperChoosen
    );
  }

  isManiger() {
    if (
      (this.user?.roles && this.user.roles.includes('su')) ||
      (this.user?.roles &&
        this.user.roles.includes('bm') &&
        this.printingService === 'plotter' &&
        this.realBranch?.plotter?.bm.toString() ===
          this.user?._id.toString()) ||
      (this.printingService === 'express' &&
        this.realBranch?.express?.bm.toString() === this.user?._id.toString())
    ) {
      return true;
    }
    return false;
  }

  isSu() {
    if (this.user?.roles && this.user.roles.includes('su')) {
      return true;
    }
    return false;
  }

  isSt() {
    if (
      this.user?.roles &&
      this.user.roles.includes('st') &&
      ((this.printingService === 'plotter' &&
        this.realBranch?.plotter?.st?.some((st) => st === this.user?._id)) ||
        (this.printingService === 'express' &&
          this.realBranch?.express?.st?.some((st) => st === this.user?._id)))
    ) {
      return true;
    }
    return false;
  }

  // Get display file name - returns originalFileName if exists, otherwise fileName
  getDisplayFileName(file: any): string {
    if (!file) {
      return '';
    }
    return file.originalFileName && file.originalFileName.trim() !== '' 
      ? file.originalFileName 
      : (file.fileName || '');
  }

  // Get display file name after split('-')[1] - for backward compatibility with existing format
  getDisplayFileNameAfterSplit(file: any): string {
    if (!file) {
      return '';
    }
    const fileName = this.getDisplayFileName(file);
    if (!fileName) {
      return '';
    }
    // If originalFileName exists, return it as is (assuming it's already the clean name)
    // Otherwise, use the split logic for fileName
    if (file.originalFileName && file.originalFileName.trim() !== '') {
      return file.originalFileName;
    }
    // For fileName, use the existing split logic
    const parts = fileName.split('-');
    return parts.length > 1 ? parts[1] : fileName;
  }

  // ------ animation ------

  // rattle Upload SVG

  // rattle effect animation
  animateUploadSVG() {
    this.ngZone.runOutsideAngular(() => {
      this.rattleInterval = setInterval(() => {
        this.ngZone.run(() => {
          this.rattle = this.rattle === 'state1' ? 'state2' : 'state1';
        });
      }, 15000);
    });
  }

  // stop the rattle effect
  stopAnimateUploadSVG() {
    clearInterval(this.rattleInterval);
    this.rattle = 'state1';
  }

  startOrStopAnimateUploadSVG() {
    if (this.files.length === 0) {
      this.animateUploadSVG();
    } else {
      this.stopAnimateUploadSVG();
    }
  }

  // No Paper

  // No Paper effect animation
  animateNoPaper() {
    // console.log("animate-No-Paper START!");
    this.noPaper = 'state2';
    this.ngZone.runOutsideAngular(() => {
      this.noPaperInterval = setInterval(() => {
        this.ngZone.run(() => {
          this.noPaper = this.noPaper === 'state1' ? 'state2' : 'state1';
        });
      }, 2800);
    });
  }

  // stop the No Paper effect
  stopAnimateNoPaper(paper: any = null) {
    // console.log("animate-No-Paper END!");
    clearInterval(this.noPaperInterval);
    this.noPaper = 'state1';
  }

  // start Or stop the No Paper effect
  startOrStopAnimateNoPaper() {
    if (
      (this.printingService === 'plotter' &&
        this.currentImage &&
        !this.currentImage.printSettings?.paperType) ||
      (this.printingService === 'express' &&
        this.currentFile &&
        !this.currentFile.printSettings?.paperType)
    ) {
      if (!this.isNoPaperAnimating) {
        this.isNoPaperAnimating = true;
        this.animateNoPaper();
        this.stopAnimateMainBtn();
      }
    } else {
      if (this.isNoPaperAnimating) {
        this.isNoPaperAnimating = false;
        this.stopAnimateNoPaper();
        this.animateMainBtn();
      }
    }
  }

  // main Btn

  // main Btn effect animation
  animateMainBtn() {
    // console.log("animate-Main-Btn START!");
    this.mainBtn = 'state2';
    this.ngZone.runOutsideAngular(() => {
      this.mainBtnInterval = setInterval(() => {
        this.ngZone.run(() => {
          this.mainBtn = this.mainBtn === 'state1' ? 'state2' : 'state1';
        });
      }, 9000);
    });
  }
  // stop the main Btn effect
  stopAnimateMainBtn() {
    // console.log("animate-Main-Btn END!");
    clearInterval(this.mainBtnInterval);
    this.mainBtn = 'state1';
  }

  // ==== pics discount animation ====
  isPicsDiscountAvalble(): boolean {
    if (
      this.printingService === 'express' &&
      this.isPicsPrinter() &&
      this.currentFile &&
      this.uploadingFiles.length === 0 &&
      this.files.length === 1 &&
      (!this.currentFile.images ||
        this.currentFile.images?.length === 0 ||
        this.currentFile.images?.length === 1) &&
      this.currentFile.printSettings?.paperType === 'תמונה קטנה'
    ) {
      return true;
    }
    return false;
  }

  isPicsDiscountOn(): boolean {
    if (
      this.printingService === 'express' &&
      this.isPicsPrinter() &&
      this.currentFile &&
      this.uploadingFiles.length === 0 &&
      this.files.length > 0 &&
      this.isPicsDiscountUsed
    ) {
      let amountOfSmallImages = 0;
      for (let file of this.files) {
        if (
          file.images?.length > 0 &&
          file.printSettings?.paperType === 'תמונה קטנה'
        ) {
          amountOfSmallImages += file.images.length;
        }
        if (amountOfSmallImages >= 2) {
          return true;
        }
      }
    }
    return false;
  }

  usePicsDiscount() {
    this.isPicsDiscountUsed = true;
  }

  playPicsDiscountAnimation() {
    // console.log('playPicsDiscountAnimation');
    if (this.isPicsDiscountAvalble()) {
      setTimeout(() => {
        this.confettiAnimation = lottie.loadAnimation({
          container: document.getElementById('animationConfettiContainer'),
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: 'assets/videos/confetti.json',
        });
      }, 5);
    }
  }

  getSmallImagePriceDiscounted(): number {
    if (
      this.realBranch &&
      this.realBranch.express &&
      this.realBranch.express.pricing &&
      this.realBranch.express.pricing.prices
    ) {
      const prices = this.realBranch.express.pricing.prices_x;
      const smallImagePrice = prices['תמונה קטנה']?.single?.color;
      if (smallImagePrice) {
        return (
          this.roundDownTowDecimal(smallImagePrice) *
          this.picsDiscountPresentege
        );
      }
    }
    return 0;
  }
  // // ==== pics discount animation ====

  goToManagementPage(page: string) {
    let branchID;
    if (this.printingService === 'plotter') {
      branchID = this.realBranch.plotter._id;
    } else if (this.printingService === 'express') {
      branchID = this.realBranch.express._id;
    }
    this.stopAnimateMainBtn();
    this.stopAnimateNoPaper();
    this.stopAnimateUploadSVG();
    this.clearAllIntervals();
    // console.log('goToManagementPage >> branchID: ', this.printingService, branchID);
    this.router.navigate(
      ['/printer/' + this.printingService + '/' + branchID],
      { queryParams: { q: page } }
    );
  }

  hasReadyFiles(): boolean {
    return this.files && this.files.some(file => file.images && file.images.length > 0);
  }

  transferFilesToUser() {
    // Filter out files that are still processing (files with no images or images.length === 0)
    const readyFiles = this.files.filter(file => file.images && file.images.length > 0);
    
    // Add paperSerialName to files/images for display in transfer dialog
    readyFiles.forEach(file => {
      if (this.printingService === 'express' && file.printSettings?.paperType) {
        // For express: add paperSerialName to file
        const paper = this.printServicePapers.find(p => p.paperName === file.printSettings.paperType);
        if (paper && paper.serial_name) {
          file.paperSerialName = paper.serial_name;
        }
      } else if (this.printingService === 'plotter') {
        // For plotter: add paperSerialName to each image
        // For plotter, we need to match by paperType.paperPrinterCode
        file.images.forEach(image => {
          if (image.printSettings?.paperType) {
            const paper = this.printServicePapers.find(p => 
              p.paperType?.paperPrinterCode === image.printSettings.paperType
            );
            if (paper && paper.paperType?.paperType) {
              image.paperSerialName = paper.paperType.paperType;
            }
          }
        });
      }
    });
    
    const serverAddress = this.printingService === 'plotter' && this.realBranch?.plotter?.printers?.[0]?.serverAddress 
      ? this.realBranch.plotter.printers[0].serverAddress 
      : '';
    const expressServerAddress = this.printingService === 'express' 
      ? this.expressServerAdress 
      : '';
    
    // Get printerID or branchID based on printing service
    let printerOrBranchID = '';
    if (this.printingService === 'plotter' && this.realBranch?.plotter?.printers?.[0]?._id) {
      printerOrBranchID = this.realBranch.plotter.printers[0]._id;
    } else if (this.printingService === 'express' && this.realBranch?.express?._id) {
      printerOrBranchID = this.realBranch.express._id;
    }
    
    this.dialogService.onOpenTransferFilesToUserDialog(
      readyFiles, 
      this.printingService,
      serverAddress,
      expressServerAddress,
      printerOrBranchID
    );
  }

  async toggleSkipRasterize(): Promise<void> {
    if (this.currentlyUploading) {
      this.stopUploading();
    }
    if (this.files && this.files.length > 0) {
      await this.onDeleteAllFiles();
    }
    this.skipRasterize = !this.skipRasterize;
    if (this.skipRasterize) {
      this.forceRasterize = false;
    }
  }

  toggleForceRasterize(): void {
    this.forceRasterize = !this.forceRasterize;
    if (this.forceRasterize) {
      this.skipRasterize = false;
    }
  }

  animatePaperStrong() {
    if (!this.isAnimatePaperStrong) {
      this.isAnimatePaperStrong = true;
      setTimeout(() => {
        this.isAnimatePaperStrong = false;
      }, 1500);
      if (this.currentFile) {
        this.snackBar.open(
          this.translateService.instant('printing-table.preview.not-avalble'),
          '',
          {
            duration: 3200,
            verticalPosition: 'top',
            panelClass: 'zx-top-snackbar',
          }
        );
      } else {
        this.snackBar.open(
          this.translateService.instant('printing-table.proccessing.explain'),
          '',
          {
            duration: 3200,
            verticalPosition: 'top',
            panelClass: 'zx-top-snackbar',
          }
        );
      }
    }
  }

  animatePaperStrongIfNeeded() {
    if (
      !this.currentPaperType &&
      this.files.length > 0 &&
      this.isOriginalImgFitPaper(
        this.selectedPaperPermanent?.paperType?.paperPrinterCode
      )
    ) {
      this.animatePaperStrong();
    }
  }

  ExplanationPrintSettings() {
    if (
      this.currentFile &&
      this.currentPrintSettings?.paperType &&
      !this.isLoading &&
      !this.isLoadingPreview
    ) {
      if (this.printingService === 'plotter') {
        this.snackBar.open(
          this.translateService.instant(
            'printing-table.preview.chainge-properties.plotter'
          ),
          '',
          {
            duration: 2200,
            verticalPosition: 'top',
            panelClass: 'zx-top-snackbar',
          }
        );
      } else if (this.printingService === 'express') {
        if (this.isPicsPrinter()) {
          this.snackBar.open(
            this.translateService.instant(
              'printing-table.preview.chainge-properties.express-images'
            ),
            '',
            {
              duration: 2200,
              verticalPosition: 'top',
              panelClass: 'zx-top-snackbar',
            }
          );
        } else {
          this.snackBar.open(
            this.translateService.instant(
              'printing-table.preview.chainge-properties.express'
            ),
            '',
            {
              duration: 2200,
              verticalPosition: 'top',
              panelClass: 'zx-top-snackbar',
            }
          );
        }
      }
    }
  }
  //  ------------------------------------------------- mainBtn              mainBtnInterval

  // express upload //

  endpoint = '';
  public uploader: FileUploader = new FileUploader({
    url: this.endpoint,
    headers: [
      {
        name: 'Authorization',
        value: 'Bearer ' + localStorage.getItem('token'),
      },
    ],
  });
  hasBaseDropZoneOver: boolean = false;
  uploadProgress: number = 0;
  uploadingFiles: FileItem[] = [];
  currentlyUploading: boolean = false;
  skipRasterize: boolean = false;
  forceRasterize: boolean = false;
  // List of formats that are not pixel-based (can be changed in the future)
  nonPixelFormats: string[] = ['pdf', 'pub', 'docx', 'csv', 'odp'];
  
  allowedExtensionsPlotter: string[] = [
    'pdf',
    'jpg',
    'jpeg',
    'png',
    'heic',
    'heif',
  ];
  allowedExtensionsExpress: string[] = [
    'pdf',
    'jpg',
    'jpeg',
    'png',
    'heic',
    'heif',
    'pub',
    'tif',
    'docx',
    'csv',
    'odp',
    'djvu',
    'bmp',
    'tiff',
  ];

  getTotalPagesCount(): number {
    // Count processing files as 1 each
    const processingFilesCount = this.proccessingFiles.length;
    
    // Count finished files as their number of pages (images.length)
    const finishedFiles = this.files.filter(file => file.images && file.images.length > 0);
    const finishedFilesPagesCount = finishedFiles.reduce((total, file) => {
      return total + (file.images?.length || 0);
    }, 0);
    
    // Sum both
    return processingFilesCount + finishedFilesPagesCount;
  }

  public fileOverBase(e: any): void {
    // console.log('fileOverBase:', e);
    this.hasBaseDropZoneOver = e;
  }

  public onFileDrop(e: any): void {
    // console.log('Files dropped:', e);
  }

  // Method to track upload progress for individual files
  public trackUploadProgress(): void {
    this.uploader.onBuildItemForm = (fileItem: FileItem, form: FormData) => {
      form.append('skipRasterize', String(this.skipRasterize));
    };

    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
      // console.log(`File: ${fileItem.file.name} is ${progress}% uploaded.`);
      this.uploadProgress = progress;
    };

    this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
      const isFileTypeAllowed = this.isFileTypeAllowed(fileItem.file?.name);
      if (isFileTypeAllowed) {
        this.uploadingFiles.push(fileItem);
        fileItem.upload(); // Automatically start uploading the file
        this.currentlyUploading = true;
        const fileSize = fileItem.file.size
          ? Math.ceil(fileItem.file.size / 1048576)
          : 0;
        // console.log('fileSize:', fileSize);

        if (fileSize > 500) {
          const allowedExtensions = this.printingService === 'express'
            ? this.allowedExtensionsExpress
            : this.allowedExtensionsPlotter;
          this.dialogService.onOpenFileIssuesDialog(
            fileItem.file.name,
            allowedExtensions,
            this.phoneNumber,
            'file-too-large',
            { fileSizeMb: fileSize }
          );
          fileItem.remove();
        } else {
          if (this.isPicsPrinter()) {
            this.isPicsDiscountAvalbleTimeOut = false;
            setTimeout(() => {
              this.isPicsDiscountAvalbleTimeOut = true;
            }, 5000);
          }
        }
      } else {
        // Get allowed extensions based on printing service
        const allowedExtensions = this.printingService === 'express' 
          ? this.allowedExtensionsExpress 
          : this.allowedExtensionsPlotter;
        
        // Open dialog instead of snackBar
        const fileFormat = fileItem.file.name.split('.').pop() || '';
        const serverAddress = this.printingService === 'express' 
          ? this.expressServerAdress 
          : (this.realBranch?.plotter?.printers?.[0]?.serverAddress || '');
        const branchName = this.realBranch?.name || '';
        const internetSpeed = this.getInternetSpeed();
        const internetSpeedValue = this.getInternetSpeedValue();
        this.dialogService.onOpenFileIssuesDialog(
          fileItem.file.name,
          allowedExtensions,
          this.phoneNumber,
          'file-format-not-supported',
          {
            serverAddress: serverAddress,
            branchName: branchName,
            printingService: this.printingService,
            fileFormat: fileFormat,
            internetSpeed: internetSpeed,
            internetSpeedValue: internetSpeedValue
          }
        );
        
        fileItem.remove();
      }
    };

    this.uploader.onErrorItem = (
      fileItem: FileItem,
      response: string,
      status: number,
      headers: any
    ) => {
      if (this.printingService === 'express') {
        this.serverAddress = this.expressServerAdress;
      } else if (this.printingService === 'plotter') {
        this.serverAddress = this.realBranch.plotter?.printers[0]?.serverAddress
          ? this.realBranch.plotter?.printers[0]?.serverAddress
          : this.serverAddress;
      }
      const isGoodInternet = this.checkInternetConnection();
      Sentry.captureException(new Error('File upload error'), {
        extra: {
          fileName: fileItem.file.name,
          status: status,
          response: response,
          printingService: this.printingService,
          userId: localStorage.getItem('userId'),
          serverAddress: this.serverAddress,
          lowInternet: !isGoodInternet,
        },
      });
      if (!isGoodInternet) {
        this.snackBar.open(
          this.translateService.instant(
            'printing-table.low-internet-connection'
          ),
          '',
          {
            duration: 2000,
            verticalPosition: 'bottom',
            panelClass: 'zx-top-snackbar',
          }
        );
      } else {
        // Open dialog instead of snackBar
        const fileFormat = fileItem.file.name.split('.').pop() || '';
        const serverAddress = this.printingService === 'express' 
          ? this.expressServerAdress 
          : (this.realBranch?.plotter?.printers?.[0]?.serverAddress || '');
        const branchName = this.realBranch?.name || '';
        const internetSpeed = this.getInternetSpeed();
        const internetSpeedValue = this.getInternetSpeedValue();
        this.dialogService.onOpenFileIssuesDialog(
          fileItem.file.name,
          [],
          this.phoneNumber,
          'file-not-received-in-server',
          {
            serverAddress: serverAddress,
            branchName: branchName,
            printingService: this.printingService,
            fileFormat: fileFormat,
            internetSpeed: internetSpeed,
            internetSpeedValue: internetSpeedValue
          }
        );
      }
    };

    this.uploader.onCompleteItem = (
      fileItem: FileItem,
      response: any,
      status: number,
      headers: any
    ) => {
      // console.log(`File: ${fileItem.file.name} uploaded successfully!`);
      // Remove the file from the uploadingFiles array after completion
      this.uploadingFiles = this.uploadingFiles.filter(
        (item) => item !== fileItem
      );
      if (this.uploadingFiles.length === 0) {
        this.currentlyUploading = false;
      }
    };
  }

  checkInternetConnection(): boolean {
    if (!navigator.onLine) {
      return false;
    }
    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      const effectiveType = connection.effectiveType;
      if (
        effectiveType === '2g' ||
        effectiveType === 'slow-2g' ||
        effectiveType === '3g'
      ) {
        return false;
      }
    }
    return true;
  }

  getInternetSpeed(): string {
    if (!navigator.onLine) {
      return 'לא מחובר';
    }
    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      if (connection.downlink) {
        return `${connection.downlink} Mbps`;
      }
      if (connection.effectiveType) {
        return connection.effectiveType.toUpperCase();
      }
    }
    return 'לא זמין';
  }

  getInternetSpeedValue(): number | null {
    if (!navigator.onLine) {
      return null;
    }
    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      if (connection.downlink) {
        return connection.downlink;
      }
    }
    return null;
  }

  isFileTypeAllowed(fileName: string): boolean {
    const fileExtension = fileName.split('.').pop();
    if (this.printingService === 'plotter') {
      return this.allowedExtensionsPlotter.includes(
        fileExtension.toLowerCase()
      );
    } else {
      return this.allowedExtensionsExpress.includes(
        fileExtension.toLowerCase()
      );
    }
  }

  branchHasFixProducts() {
    if (
      this.realBranch?.express?.fix_products &&
      this.realBranch.express.fix_products.length > 0
    ) {
      return true;
    }
    return false;
  }

  openFixProductsDialog(event: MouseEvent) {
    // Check if the click event was inside the tooltip element
    const isClickInsideTooltip = (event.target as Element).classList.contains(
      'i-explain-icon'
    );

    // Check if the device is a mobile device
    const isMobileDevice = window.innerWidth <= 768;

    // Only open the dialog if the device is not a mobile device, or if the click was not inside the tooltip element

    if (!isMobileDevice || !isClickInsideTooltip) {
      if (
        this.realBranch?.express?.fix_products &&
        this.realBranch.express.fix_products.length > 0
      ) {
        this.dialogService.onOpenFixProductsDialog(
          this.realBranch.name,
          this.realBranch.express.fix_products
        );
      }
    }
  }

  totalOrderdFixProducts() {
    let totalCopies = 0;
    if (this.branchHasFixProducts()) {
      for (let product of this.realBranch.express.fix_products) {
        if (product?.numOfCopies && product.numOfCopies > 0) {
          totalCopies += product.numOfCopies;
        }
      }
    }
    return totalCopies;
  }

  totalOrderdFixProductsPrice() {
    let totalPrice = 0;
    if (this.branchHasFixProducts()) {
      for (let product of this.realBranch.express.fix_products) {
        if (product.price && product.numOfCopies > 0) {
          totalPrice += product.numOfCopies * product.price;
        } else {
          totalPrice += product.numOfCopies * product.productId.defaultPrice;
        }
      }
    }
    return totalPrice;
  }

  clearFixProducts() {
    if (this.realBranch?.express?.fix_products) {
      this.realBranch.express.fix_products.forEach((product) => {
        product.numOfCopies = 0;
      });
    }
  }

  isPicsPrinter() {
    if (
      this.printingService === 'express' &&
      this.realBranch.express?.isPicsPrinter
    ) {
      return true;
    }
    return false;
  }

  beforeUnloadHandler(event: BeforeUnloadEvent): string {
    const token = localStorage.getItem('token');
    if (token && token !== '' && token !== 'null') {
      const confirmationMessage =
        'Reload site? Changes you made may not be saved.';
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    } else {
      return null;
    }
  }

  getCurrentDpiPlotter() {
    const format = this.currentFile.fileName.split('.').pop();
    if (
      format &&
      this.currentImage?.origImageDPI &&
      (format === 'jpeg' || format === 'jpg' || format === 'png')
    ) {
      return this.currentImage.origImageDPI;
    }
    return 300;
  }

  // Check if file should trigger weird-dpi dialog
  checkAndOpenWeirdDpiDialog(file: any, image: any) {
    // Check if isDpiUpdated is not in localStorage or not equal to "true"
    const isDpiUpdated = localStorage.getItem('isDpiUpdated');
    if (isDpiUpdated === 'true') {
      return; // Already shown, don't show again
    }

    if (this.isPicsPrinter()) {
      return; // Express pics printers: non-standard DPI notice not relevant
    }

    // Check if image has DPI
    if (!image.origImageDPI) {
      return; // No DPI information
    }

    // Check if DPI is not one of: 150, 300, 600
    const dpi = image.origImageDPI;
    if (dpi === 150 || dpi === 300 || dpi === 600) {
      return; // DPI is standard
    }

    // Get file format
    const fileFormat = file.fileName ? file.fileName.split('.').pop()?.toLowerCase() : '';
    if (!fileFormat) {
      return; // No file format
    }

    // Check if file format is not in nonPixelFormats list
    if (this.nonPixelFormats.includes(fileFormat)) {
      return; // File format is in the list, don't show dialog
    }

    // All conditions met - open dialog
    localStorage.setItem('isDpiUpdated', 'true');
    
    const serverAddress = this.printingService === 'express' 
      ? this.expressServerAdress 
      : (this.realBranch?.plotter?.printers?.[0]?.serverAddress || '');
    const branchName = this.realBranch?.name || '';
    
    this.dialogService.onOpenFileIssuesDialog(
      file.fileName,
      [],
      this.phoneNumber,
      'weird-dpi',
      {
        serverAddress: serverAddress,
        branchName: branchName,
        printingService: this.printingService,
        fileFormat: fileFormat,
        dpi: dpi
      }
    );
  }

  // ===============
}
